"use strict";

var _Object$keys2 = require("@babel/runtime-corejs2/core-js/object/keys");
var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");
var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors");
var _Object$defineProperties = require("@babel/runtime-corejs2/core-js/object/define-properties");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TeamModel = exports.SiteModel = exports.PerformanceModel = exports.PackageLineModel = exports.HospitalitySessionModel = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
require("core-js/modules/es6.function.name.js");
require("core-js/modules/es6.array.map.js");
require("core-js/modules/es6.array.filter.js");
require("core-js/modules/es6.regexp.replace.js");
require("core-js/modules/es6.array.find.js");
var _values = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/values"));
var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));
var _assign = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/assign"));
var _entries = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/entries"));
var _compare_asc = _interopRequireDefault(require("date-fns/compare_asc"));
var _format = _interopRequireDefault(require("date-fns/format"));
var _findIndex = _interopRequireDefault(require("lodash/findIndex"));
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
var _groupBy = _interopRequireDefault(require("lodash/groupBy"));
var _get2 = _interopRequireDefault(require("lodash/get"));
function cov_2lqxhfvlrd() {
  var path = "/codebuild/output/src1603853905/src/git-codecommit.eu-central-1.amazonaws.com/v1/repos/gravity/apps/tnwi/temp/nucleo/product/lib/model.js";
  var hash = "228761a7ec6bca6cf0de427602137a41f491fd21";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src1603853905/src/git-codecommit.eu-central-1.amazonaws.com/v1/repos/gravity/apps/tnwi/temp/nucleo/product/lib/model.js",
    statementMap: {
      "0": {
        start: {
          line: 8,
          column: 16
        },
        end: {
          line: 9,
          column: 89
        }
      },
      "1": {
        start: {
          line: 9,
          column: 2
        },
        end: {
          line: 9,
          column: 89
        }
      },
      "2": {
        start: {
          line: 11,
          column: 20
        },
        end: {
          line: 66,
          column: 1
        }
      },
      "3": {
        start: {
          line: 22,
          column: 22
        },
        end: {
          line: 22,
          column: 52
        }
      },
      "4": {
        start: {
          line: 23,
          column: 42
        },
        end: {
          line: 23,
          column: 48
        }
      },
      "5": {
        start: {
          line: 24,
          column: 4
        },
        end: {
          line: 42,
          column: 6
        }
      },
      "6": {
        start: {
          line: 45,
          column: 19
        },
        end: {
          line: 45,
          column: 48
        }
      },
      "7": {
        start: {
          line: 46,
          column: 4
        },
        end: {
          line: 53,
          column: 6
        }
      },
      "8": {
        start: {
          line: 62,
          column: 58
        },
        end: {
          line: 65,
          column: 3
        }
      },
      "9": {
        start: {
          line: 68,
          column: 25
        },
        end: {
          line: 86,
          column: 1
        }
      },
      "10": {
        start: {
          line: 77,
          column: 42
        },
        end: {
          line: 77,
          column: 48
        }
      },
      "11": {
        start: {
          line: 78,
          column: 24
        },
        end: {
          line: 82,
          column: 5
        }
      },
      "12": {
        start: {
          line: 84,
          column: 4
        },
        end: {
          line: 84,
          column: 39
        }
      },
      "13": {
        start: {
          line: 88,
          column: 25
        },
        end: {
          line: 114,
          column: 1
        }
      },
      "14": {
        start: {
          line: 97,
          column: 42
        },
        end: {
          line: 97,
          column: 48
        }
      },
      "15": {
        start: {
          line: 98,
          column: 24
        },
        end: {
          line: 102,
          column: 5
        }
      },
      "16": {
        start: {
          line: 103,
          column: 4
        },
        end: {
          line: 103,
          column: 39
        }
      },
      "17": {
        start: {
          line: 107,
          column: 24
        },
        end: {
          line: 110,
          column: 5
        }
      },
      "18": {
        start: {
          line: 112,
          column: 4
        },
        end: {
          line: 112,
          column: 39
        }
      },
      "19": {
        start: {
          line: 116,
          column: 39
        },
        end: {
          line: 174,
          column: 1
        }
      },
      "20": {
        start: {
          line: 127,
          column: 42
        },
        end: {
          line: 127,
          column: 48
        }
      },
      "21": {
        start: {
          line: 128,
          column: 24
        },
        end: {
          line: 145,
          column: 5
        }
      },
      "22": {
        start: {
          line: 146,
          column: 4
        },
        end: {
          line: 146,
          column: 39
        }
      },
      "23": {
        start: {
          line: 153,
          column: 24
        },
        end: {
          line: 170,
          column: 5
        }
      },
      "24": {
        start: {
          line: 172,
          column: 4
        },
        end: {
          line: 172,
          column: 39
        }
      },
      "25": {
        start: {
          line: 176,
          column: 32
        },
        end: {
          line: 417,
          column: 1
        }
      },
      "26": {
        start: {
          line: 187,
          column: 42
        },
        end: {
          line: 187,
          column: 48
        }
      },
      "27": {
        start: {
          line: 188,
          column: 21
        },
        end: {
          line: 188,
          column: 30
        }
      },
      "28": {
        start: {
          line: 190,
          column: 4
        },
        end: {
          line: 192,
          column: 5
        }
      },
      "29": {
        start: {
          line: 191,
          column: 6
        },
        end: {
          line: 191,
          column: 39
        }
      },
      "30": {
        start: {
          line: 193,
          column: 24
        },
        end: {
          line: 215,
          column: 5
        }
      },
      "31": {
        start: {
          line: 217,
          column: 4
        },
        end: {
          line: 223,
          column: 5
        }
      },
      "32": {
        start: {
          line: 218,
          column: 6
        },
        end: {
          line: 220,
          column: 8
        }
      },
      "33": {
        start: {
          line: 219,
          column: 8
        },
        end: {
          line: 219,
          column: 55
        }
      },
      "34": {
        start: {
          line: 221,
          column: 6
        },
        end: {
          line: 221,
          column: 99
        }
      },
      "35": {
        start: {
          line: 221,
          column: 76
        },
        end: {
          line: 221,
          column: 97
        }
      },
      "36": {
        start: {
          line: 222,
          column: 6
        },
        end: {
          line: 222,
          column: 37
        }
      },
      "37": {
        start: {
          line: 224,
          column: 19
        },
        end: {
          line: 224,
          column: 46
        }
      },
      "38": {
        start: {
          line: 225,
          column: 4
        },
        end: {
          line: 225,
          column: 34
        }
      },
      "39": {
        start: {
          line: 226,
          column: 4
        },
        end: {
          line: 226,
          column: 18
        }
      },
      "40": {
        start: {
          line: 233,
          column: 24
        },
        end: {
          line: 256,
          column: 5
        }
      },
      "41": {
        start: {
          line: 258,
          column: 4
        },
        end: {
          line: 258,
          column: 39
        }
      },
      "42": {
        start: {
          line: 273,
          column: 40
        },
        end: {
          line: 273,
          column: 46
        }
      },
      "43": {
        start: {
          line: 274,
          column: 24
        },
        end: {
          line: 274,
          column: 62
        }
      },
      "44": {
        start: {
          line: 276,
          column: 4
        },
        end: {
          line: 278,
          column: 5
        }
      },
      "45": {
        start: {
          line: 277,
          column: 6
        },
        end: {
          line: 277,
          column: 18
        }
      },
      "46": {
        start: {
          line: 279,
          column: 4
        },
        end: {
          line: 330,
          column: 5
        }
      },
      "47": {
        start: {
          line: 281,
          column: 8
        },
        end: {
          line: 281,
          column: 74
        }
      },
      "48": {
        start: {
          line: 282,
          column: 8
        },
        end: {
          line: 282,
          column: 79
        }
      },
      "49": {
        start: {
          line: 283,
          column: 8
        },
        end: {
          line: 283,
          column: 75
        }
      },
      "50": {
        start: {
          line: 284,
          column: 8
        },
        end: {
          line: 287,
          column: 10
        }
      },
      "51": {
        start: {
          line: 289,
          column: 8
        },
        end: {
          line: 291,
          column: 9
        }
      },
      "52": {
        start: {
          line: 290,
          column: 10
        },
        end: {
          line: 290,
          column: 85
        }
      },
      "53": {
        start: {
          line: 290,
          column: 48
        },
        end: {
          line: 290,
          column: 78
        }
      },
      "54": {
        start: {
          line: 292,
          column: 8
        },
        end: {
          line: 292,
          column: 20
        }
      },
      "55": {
        start: {
          line: 294,
          column: 8
        },
        end: {
          line: 296,
          column: 9
        }
      },
      "56": {
        start: {
          line: 295,
          column: 10
        },
        end: {
          line: 295,
          column: 86
        }
      },
      "57": {
        start: {
          line: 295,
          column: 48
        },
        end: {
          line: 295,
          column: 79
        }
      },
      "58": {
        start: {
          line: 297,
          column: 8
        },
        end: {
          line: 297,
          column: 20
        }
      },
      "59": {
        start: {
          line: 299,
          column: 8
        },
        end: {
          line: 301,
          column: 9
        }
      },
      "60": {
        start: {
          line: 300,
          column: 10
        },
        end: {
          line: 300,
          column: 78
        }
      },
      "61": {
        start: {
          line: 302,
          column: 8
        },
        end: {
          line: 302,
          column: 20
        }
      },
      "62": {
        start: {
          line: 304,
          column: 8
        },
        end: {
          line: 306,
          column: 9
        }
      },
      "63": {
        start: {
          line: 305,
          column: 10
        },
        end: {
          line: 305,
          column: 84
        }
      },
      "64": {
        start: {
          line: 307,
          column: 8
        },
        end: {
          line: 307,
          column: 20
        }
      },
      "65": {
        start: {
          line: 309,
          column: 8
        },
        end: {
          line: 311,
          column: 9
        }
      },
      "66": {
        start: {
          line: 310,
          column: 10
        },
        end: {
          line: 310,
          column: 90
        }
      },
      "67": {
        start: {
          line: 312,
          column: 8
        },
        end: {
          line: 312,
          column: 20
        }
      },
      "68": {
        start: {
          line: 314,
          column: 8
        },
        end: {
          line: 316,
          column: 9
        }
      },
      "69": {
        start: {
          line: 315,
          column: 10
        },
        end: {
          line: 315,
          column: 83
        }
      },
      "70": {
        start: {
          line: 317,
          column: 8
        },
        end: {
          line: 317,
          column: 20
        }
      },
      "71": {
        start: {
          line: 319,
          column: 8
        },
        end: {
          line: 321,
          column: 9
        }
      },
      "72": {
        start: {
          line: 320,
          column: 10
        },
        end: {
          line: 320,
          column: 87
        }
      },
      "73": {
        start: {
          line: 322,
          column: 8
        },
        end: {
          line: 322,
          column: 20
        }
      },
      "74": {
        start: {
          line: 324,
          column: 8
        },
        end: {
          line: 326,
          column: 9
        }
      },
      "75": {
        start: {
          line: 325,
          column: 10
        },
        end: {
          line: 325,
          column: 83
        }
      },
      "76": {
        start: {
          line: 327,
          column: 8
        },
        end: {
          line: 327,
          column: 20
        }
      },
      "77": {
        start: {
          line: 329,
          column: 8
        },
        end: {
          line: 329,
          column: 20
        }
      },
      "78": {
        start: {
          line: 342,
          column: 21
        },
        end: {
          line: 342,
          column: 22
        }
      },
      "79": {
        start: {
          line: 343,
          column: 24
        },
        end: {
          line: 343,
          column: 70
        }
      },
      "80": {
        start: {
          line: 344,
          column: 4
        },
        end: {
          line: 359,
          column: 5
        }
      },
      "81": {
        start: {
          line: 345,
          column: 19
        },
        end: {
          line: 345,
          column: 21
        }
      },
      "82": {
        start: {
          line: 346,
          column: 19
        },
        end: {
          line: 346,
          column: 21
        }
      },
      "83": {
        start: {
          line: 347,
          column: 6
        },
        end: {
          line: 349,
          column: 7
        }
      },
      "84": {
        start: {
          line: 348,
          column: 8
        },
        end: {
          line: 348,
          column: 43
        }
      },
      "85": {
        start: {
          line: 350,
          column: 6
        },
        end: {
          line: 352,
          column: 7
        }
      },
      "86": {
        start: {
          line: 351,
          column: 8
        },
        end: {
          line: 351,
          column: 43
        }
      },
      "87": {
        start: {
          line: 354,
          column: 6
        },
        end: {
          line: 358,
          column: 7
        }
      },
      "88": {
        start: {
          line: 355,
          column: 8
        },
        end: {
          line: 355,
          column: 40
        }
      },
      "89": {
        start: {
          line: 356,
          column: 13
        },
        end: {
          line: 358,
          column: 7
        }
      },
      "90": {
        start: {
          line: 357,
          column: 8
        },
        end: {
          line: 357,
          column: 40
        }
      },
      "91": {
        start: {
          line: 361,
          column: 4
        },
        end: {
          line: 361,
          column: 22
        }
      },
      "92": {
        start: {
          line: 364,
          column: 4
        },
        end: {
          line: 379,
          column: 5
        }
      },
      "93": {
        start: {
          line: 366,
          column: 8
        },
        end: {
          line: 366,
          column: 22
        }
      },
      "94": {
        start: {
          line: 368,
          column: 8
        },
        end: {
          line: 368,
          column: 27
        }
      },
      "95": {
        start: {
          line: 370,
          column: 8
        },
        end: {
          line: 370,
          column: 29
        }
      },
      "96": {
        start: {
          line: 372,
          column: 8
        },
        end: {
          line: 372,
          column: 23
        }
      },
      "97": {
        start: {
          line: 374,
          column: 8
        },
        end: {
          line: 374,
          column: 27
        }
      },
      "98": {
        start: {
          line: 376,
          column: 8
        },
        end: {
          line: 376,
          column: 30
        }
      },
      "99": {
        start: {
          line: 378,
          column: 8
        },
        end: {
          line: 378,
          column: 20
        }
      },
      "100": {
        start: {
          line: 390,
          column: 20
        },
        end: {
          line: 390,
          column: 25
        }
      },
      "101": {
        start: {
          line: 392,
          column: 27
        },
        end: {
          line: 392,
          column: 77
        }
      },
      "102": {
        start: {
          line: 392,
          column: 50
        },
        end: {
          line: 392,
          column: 76
        }
      },
      "103": {
        start: {
          line: 393,
          column: 4
        },
        end: {
          line: 403,
          column: 7
        }
      },
      "104": {
        start: {
          line: 394,
          column: 27
        },
        end: {
          line: 394,
          column: 46
        }
      },
      "105": {
        start: {
          line: 396,
          column: 6
        },
        end: {
          line: 402,
          column: 76
        }
      },
      "106": {
        start: {
          line: 404,
          column: 4
        },
        end: {
          line: 404,
          column: 21
        }
      },
      "107": {
        start: {
          line: 416,
          column: 4
        },
        end: {
          line: 416,
          column: 57
        }
      },
      "108": {
        start: {
          line: 416,
          column: 23
        },
        end: {
          line: 416,
          column: 56
        }
      },
      "109": {
        start: {
          line: 419,
          column: 24
        },
        end: {
          line: 451,
          column: 1
        }
      },
      "110": {
        start: {
          line: 428,
          column: 42
        },
        end: {
          line: 428,
          column: 48
        }
      },
      "111": {
        start: {
          line: 429,
          column: 24
        },
        end: {
          line: 433,
          column: 5
        }
      },
      "112": {
        start: {
          line: 434,
          column: 4
        },
        end: {
          line: 434,
          column: 39
        }
      },
      "113": {
        start: {
          line: 444,
          column: 24
        },
        end: {
          line: 448,
          column: 5
        }
      },
      "114": {
        start: {
          line: 449,
          column: 4
        },
        end: {
          line: 449,
          column: 45
        }
      },
      "115": {
        start: {
          line: 453,
          column: 22
        },
        end: {
          line: 491,
          column: 1
        }
      },
      "116": {
        start: {
          line: 463,
          column: 24
        },
        end: {
          line: 463,
          column: 26
        }
      },
      "117": {
        start: {
          line: 464,
          column: 4
        },
        end: {
          line: 468,
          column: 5
        }
      },
      "118": {
        start: {
          line: 465,
          column: 6
        },
        end: {
          line: 467,
          column: 8
        }
      },
      "119": {
        start: {
          line: 466,
          column: 8
        },
        end: {
          line: 466,
          column: 47
        }
      },
      "120": {
        start: {
          line: 469,
          column: 4
        },
        end: {
          line: 471,
          column: 6
        }
      },
      "121": {
        start: {
          line: 470,
          column: 15
        },
        end: {
          line: 470,
          column: 45
        }
      },
      "122": {
        start: {
          line: 473,
          column: 4
        },
        end: {
          line: 473,
          column: 39
        }
      },
      "123": {
        start: {
          line: 483,
          column: 24
        },
        end: {
          line: 483,
          column: 26
        }
      },
      "124": {
        start: {
          line: 484,
          column: 4
        },
        end: {
          line: 488,
          column: 5
        }
      },
      "125": {
        start: {
          line: 485,
          column: 6
        },
        end: {
          line: 487,
          column: 8
        }
      },
      "126": {
        start: {
          line: 486,
          column: 8
        },
        end: {
          line: 486,
          column: 77
        }
      },
      "127": {
        start: {
          line: 489,
          column: 4
        },
        end: {
          line: 489,
          column: 40
        }
      },
      "128": {
        start: {
          line: 493,
          column: 23
        },
        end: {
          line: 533,
          column: 1
        }
      },
      "129": {
        start: {
          line: 502,
          column: 42
        },
        end: {
          line: 502,
          column: 48
        }
      },
      "130": {
        start: {
          line: 503,
          column: 24
        },
        end: {
          line: 511,
          column: 5
        }
      },
      "131": {
        start: {
          line: 512,
          column: 4
        },
        end: {
          line: 512,
          column: 39
        }
      },
      "132": {
        start: {
          line: 522,
          column: 24
        },
        end: {
          line: 530,
          column: 5
        }
      },
      "133": {
        start: {
          line: 531,
          column: 4
        },
        end: {
          line: 531,
          column: 44
        }
      },
      "134": {
        start: {
          line: 535,
          column: 21
        },
        end: {
          line: 740,
          column: 1
        }
      },
      "135": {
        start: {
          line: 544,
          column: 42
        },
        end: {
          line: 544,
          column: 48
        }
      },
      "136": {
        start: {
          line: 545,
          column: 24
        },
        end: {
          line: 561,
          column: 5
        }
      },
      "137": {
        start: {
          line: 562,
          column: 4
        },
        end: {
          line: 564,
          column: 6
        }
      },
      "138": {
        start: {
          line: 563,
          column: 6
        },
        end: {
          line: 563,
          column: 60
        }
      },
      "139": {
        start: {
          line: 566,
          column: 29
        },
        end: {
          line: 566,
          column: 76
        }
      },
      "140": {
        start: {
          line: 566,
          column: 59
        },
        end: {
          line: 566,
          column: 75
        }
      },
      "141": {
        start: {
          line: 567,
          column: 4
        },
        end: {
          line: 569,
          column: 6
        }
      },
      "142": {
        start: {
          line: 568,
          column: 6
        },
        end: {
          line: 568,
          column: 59
        }
      },
      "143": {
        start: {
          line: 571,
          column: 4
        },
        end: {
          line: 573,
          column: 6
        }
      },
      "144": {
        start: {
          line: 572,
          column: 6
        },
        end: {
          line: 572,
          column: 50
        }
      },
      "145": {
        start: {
          line: 575,
          column: 4
        },
        end: {
          line: 580,
          column: 6
        }
      },
      "146": {
        start: {
          line: 578,
          column: 8
        },
        end: {
          line: 578,
          column: 49
        }
      },
      "147": {
        start: {
          line: 581,
          column: 4
        },
        end: {
          line: 583,
          column: 6
        }
      },
      "148": {
        start: {
          line: 582,
          column: 6
        },
        end: {
          line: 582,
          column: 43
        }
      },
      "149": {
        start: {
          line: 585,
          column: 4
        },
        end: {
          line: 591,
          column: 5
        }
      },
      "150": {
        start: {
          line: 586,
          column: 6
        },
        end: {
          line: 590,
          column: 8
        }
      },
      "151": {
        start: {
          line: 593,
          column: 4
        },
        end: {
          line: 596,
          column: 5
        }
      },
      "152": {
        start: {
          line: 594,
          column: 6
        },
        end: {
          line: 594,
          column: 97
        }
      },
      "153": {
        start: {
          line: 594,
          column: 65
        },
        end: {
          line: 594,
          column: 95
        }
      },
      "154": {
        start: {
          line: 595,
          column: 6
        },
        end: {
          line: 595,
          column: 37
        }
      },
      "155": {
        start: {
          line: 598,
          column: 4
        },
        end: {
          line: 598,
          column: 39
        }
      },
      "156": {
        start: {
          line: 608,
          column: 27
        },
        end: {
          line: 617,
          column: 5
        }
      },
      "157": {
        start: {
          line: 620,
          column: 4
        },
        end: {
          line: 622,
          column: 6
        }
      },
      "158": {
        start: {
          line: 621,
          column: 6
        },
        end: {
          line: 621,
          column: 93
        }
      },
      "159": {
        start: {
          line: 625,
          column: 4
        },
        end: {
          line: 627,
          column: 6
        }
      },
      "160": {
        start: {
          line: 626,
          column: 6
        },
        end: {
          line: 626,
          column: 71
        }
      },
      "161": {
        start: {
          line: 630,
          column: 4
        },
        end: {
          line: 632,
          column: 6
        }
      },
      "162": {
        start: {
          line: 631,
          column: 6
        },
        end: {
          line: 631,
          column: 80
        }
      },
      "163": {
        start: {
          line: 635,
          column: 4
        },
        end: {
          line: 640,
          column: 6
        }
      },
      "164": {
        start: {
          line: 638,
          column: 8
        },
        end: {
          line: 638,
          column: 79
        }
      },
      "165": {
        start: {
          line: 643,
          column: 4
        },
        end: {
          line: 645,
          column: 6
        }
      },
      "166": {
        start: {
          line: 644,
          column: 6
        },
        end: {
          line: 644,
          column: 73
        }
      },
      "167": {
        start: {
          line: 648,
          column: 4
        },
        end: {
          line: 650,
          column: 6
        }
      },
      "168": {
        start: {
          line: 649,
          column: 6
        },
        end: {
          line: 649,
          column: 67
        }
      },
      "169": {
        start: {
          line: 652,
          column: 4
        },
        end: {
          line: 658,
          column: 5
        }
      },
      "170": {
        start: {
          line: 653,
          column: 6
        },
        end: {
          line: 657,
          column: 8
        }
      },
      "171": {
        start: {
          line: 660,
          column: 4
        },
        end: {
          line: 660,
          column: 54
        }
      },
      "172": {
        start: {
          line: 665,
          column: 22
        },
        end: {
          line: 665,
          column: 110
        }
      },
      "173": {
        start: {
          line: 668,
          column: 18
        },
        end: {
          line: 668,
          column: 48
        }
      },
      "174": {
        start: {
          line: 669,
          column: 18
        },
        end: {
          line: 669,
          column: 48
        }
      },
      "175": {
        start: {
          line: 670,
          column: 23
        },
        end: {
          line: 670,
          column: 47
        }
      },
      "176": {
        start: {
          line: 672,
          column: 4
        },
        end: {
          line: 674,
          column: 5
        }
      },
      "177": {
        start: {
          line: 673,
          column: 6
        },
        end: {
          line: 673,
          column: 24
        }
      },
      "178": {
        start: {
          line: 676,
          column: 18
        },
        end: {
          line: 676,
          column: 63
        }
      },
      "179": {
        start: {
          line: 677,
          column: 18
        },
        end: {
          line: 677,
          column: 63
        }
      },
      "180": {
        start: {
          line: 679,
          column: 4
        },
        end: {
          line: 679,
          column: 38
        }
      },
      "181": {
        start: {
          line: 682,
          column: 22
        },
        end: {
          line: 682,
          column: 34
        }
      },
      "182": {
        start: {
          line: 687,
          column: 24
        },
        end: {
          line: 687,
          column: 69
        }
      },
      "183": {
        start: {
          line: 697,
          column: 24
        },
        end: {
          line: 697,
          column: 60
        }
      },
      "184": {
        start: {
          line: 699,
          column: 4
        },
        end: {
          line: 704,
          column: 5
        }
      },
      "185": {
        start: {
          line: 700,
          column: 6
        },
        end: {
          line: 700,
          column: 84
        }
      },
      "186": {
        start: {
          line: 700,
          column: 44
        },
        end: {
          line: 700,
          column: 82
        }
      },
      "187": {
        start: {
          line: 701,
          column: 11
        },
        end: {
          line: 704,
          column: 5
        }
      },
      "188": {
        start: {
          line: 703,
          column: 6
        },
        end: {
          line: 703,
          column: 28
        }
      },
      "189": {
        start: {
          line: 705,
          column: 4
        },
        end: {
          line: 705,
          column: 21
        }
      },
      "190": {
        start: {
          line: 709,
          column: 23
        },
        end: {
          line: 709,
          column: 50
        }
      },
      "191": {
        start: {
          line: 709,
          column: 30
        },
        end: {
          line: 709,
          column: 50
        }
      },
      "192": {
        start: {
          line: 710,
          column: 4
        },
        end: {
          line: 712,
          column: 5
        }
      },
      "193": {
        start: {
          line: 711,
          column: 6
        },
        end: {
          line: 711,
          column: 33
        }
      },
      "194": {
        start: {
          line: 713,
          column: 4
        },
        end: {
          line: 715,
          column: 5
        }
      },
      "195": {
        start: {
          line: 714,
          column: 6
        },
        end: {
          line: 714,
          column: 34
        }
      },
      "196": {
        start: {
          line: 716,
          column: 4
        },
        end: {
          line: 718,
          column: 5
        }
      },
      "197": {
        start: {
          line: 717,
          column: 6
        },
        end: {
          line: 717,
          column: 31
        }
      },
      "198": {
        start: {
          line: 719,
          column: 4
        },
        end: {
          line: 719,
          column: 14
        }
      },
      "199": {
        start: {
          line: 727,
          column: 24
        },
        end: {
          line: 727,
          column: 60
        }
      },
      "200": {
        start: {
          line: 728,
          column: 4
        },
        end: {
          line: 728,
          column: 65
        }
      },
      "201": {
        start: {
          line: 731,
          column: 45
        },
        end: {
          line: 737,
          column: 3
        }
      },
      "202": {
        start: {
          line: 734,
          column: 6
        },
        end: {
          line: 734,
          column: 44
        }
      },
      "203": {
        start: {
          line: 735,
          column: 6
        },
        end: {
          line: 735,
          column: 17
        }
      },
      "204": {
        start: {
          line: 739,
          column: 29
        },
        end: {
          line: 739,
          column: 66
        }
      },
      "205": {
        start: {
          line: 742,
          column: 32
        },
        end: {
          line: 770,
          column: 1
        }
      },
      "206": {
        start: {
          line: 752,
          column: 24
        },
        end: {
          line: 755,
          column: 5
        }
      },
      "207": {
        start: {
          line: 756,
          column: 4
        },
        end: {
          line: 756,
          column: 39
        }
      },
      "208": {
        start: {
          line: 763,
          column: 24
        },
        end: {
          line: 766,
          column: 5
        }
      },
      "209": {
        start: {
          line: 768,
          column: 4
        },
        end: {
          line: 768,
          column: 39
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 8,
            column: 16
          },
          end: {
            line: 8,
            column: 17
          }
        },
        loc: {
          start: {
            line: 9,
            column: 2
          },
          end: {
            line: 9,
            column: 89
          }
        },
        line: 9
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 21,
            column: 7
          },
          end: {
            line: 21,
            column: 8
          }
        },
        loc: {
          start: {
            line: 21,
            column: 25
          },
          end: {
            line: 43,
            column: 3
          }
        },
        line: 21
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 44,
            column: 24
          },
          end: {
            line: 44,
            column: 25
          }
        },
        loc: {
          start: {
            line: 44,
            column: 42
          },
          end: {
            line: 54,
            column: 3
          }
        },
        line: 44
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 62,
            column: 18
          },
          end: {
            line: 62,
            column: 19
          }
        },
        loc: {
          start: {
            line: 62,
            column: 58
          },
          end: {
            line: 65,
            column: 3
          }
        },
        line: 62
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 76,
            column: 7
          },
          end: {
            line: 76,
            column: 8
          }
        },
        loc: {
          start: {
            line: 76,
            column: 25
          },
          end: {
            line: 85,
            column: 3
          }
        },
        line: 76
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 96,
            column: 7
          },
          end: {
            line: 96,
            column: 8
          }
        },
        loc: {
          start: {
            line: 96,
            column: 25
          },
          end: {
            line: 104,
            column: 3
          }
        },
        line: 96
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 106,
            column: 18
          },
          end: {
            line: 106,
            column: 19
          }
        },
        loc: {
          start: {
            line: 106,
            column: 55
          },
          end: {
            line: 113,
            column: 3
          }
        },
        line: 106
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 126,
            column: 7
          },
          end: {
            line: 126,
            column: 8
          }
        },
        loc: {
          start: {
            line: 126,
            column: 25
          },
          end: {
            line: 147,
            column: 3
          }
        },
        line: 126
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 152,
            column: 18
          },
          end: {
            line: 152,
            column: 19
          }
        },
        loc: {
          start: {
            line: 152,
            column: 55
          },
          end: {
            line: 173,
            column: 3
          }
        },
        line: 152
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 186,
            column: 7
          },
          end: {
            line: 186,
            column: 8
          }
        },
        loc: {
          start: {
            line: 186,
            column: 38
          },
          end: {
            line: 227,
            column: 3
          }
        },
        line: 186
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 218,
            column: 44
          },
          end: {
            line: 218,
            column: 45
          }
        },
        loc: {
          start: {
            line: 219,
            column: 8
          },
          end: {
            line: 219,
            column: 55
          }
        },
        line: 219
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 221,
            column: 66
          },
          end: {
            line: 221,
            column: 67
          }
        },
        loc: {
          start: {
            line: 221,
            column: 76
          },
          end: {
            line: 221,
            column: 97
          }
        },
        line: 221
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 232,
            column: 18
          },
          end: {
            line: 232,
            column: 19
          }
        },
        loc: {
          start: {
            line: 232,
            column: 68
          },
          end: {
            line: 259,
            column: 3
          }
        },
        line: 232
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 269,
            column: 12
          },
          end: {
            line: 269,
            column: 13
          }
        },
        loc: {
          start: {
            line: 269,
            column: 40
          },
          end: {
            line: 331,
            column: 3
          }
        },
        line: 269
      },
      "14": {
        name: "(anonymous_14)",
        decl: {
          start: {
            line: 290,
            column: 40
          },
          end: {
            line: 290,
            column: 41
          }
        },
        loc: {
          start: {
            line: 290,
            column: 48
          },
          end: {
            line: 290,
            column: 78
          }
        },
        line: 290
      },
      "15": {
        name: "(anonymous_15)",
        decl: {
          start: {
            line: 295,
            column: 40
          },
          end: {
            line: 295,
            column: 41
          }
        },
        loc: {
          start: {
            line: 295,
            column: 48
          },
          end: {
            line: 295,
            column: 79
          }
        },
        line: 295
      },
      "16": {
        name: "(anonymous_16)",
        decl: {
          start: {
            line: 341,
            column: 15
          },
          end: {
            line: 341,
            column: 16
          }
        },
        loc: {
          start: {
            line: 341,
            column: 65
          },
          end: {
            line: 362,
            column: 3
          }
        },
        line: 341
      },
      "17": {
        name: "(anonymous_17)",
        decl: {
          start: {
            line: 363,
            column: 26
          },
          end: {
            line: 363,
            column: 27
          }
        },
        loc: {
          start: {
            line: 363,
            column: 35
          },
          end: {
            line: 380,
            column: 3
          }
        },
        line: 363
      },
      "18": {
        name: "(anonymous_18)",
        decl: {
          start: {
            line: 389,
            column: 21
          },
          end: {
            line: 389,
            column: 22
          }
        },
        loc: {
          start: {
            line: 389,
            column: 46
          },
          end: {
            line: 405,
            column: 3
          }
        },
        line: 389
      },
      "19": {
        name: "(anonymous_19)",
        decl: {
          start: {
            line: 392,
            column: 41
          },
          end: {
            line: 392,
            column: 42
          }
        },
        loc: {
          start: {
            line: 392,
            column: 50
          },
          end: {
            line: 392,
            column: 76
          }
        },
        line: 392
      },
      "20": {
        name: "(anonymous_20)",
        decl: {
          start: {
            line: 393,
            column: 27
          },
          end: {
            line: 393,
            column: 28
          }
        },
        loc: {
          start: {
            line: 393,
            column: 36
          },
          end: {
            line: 403,
            column: 5
          }
        },
        line: 393
      },
      "21": {
        name: "(anonymous_21)",
        decl: {
          start: {
            line: 415,
            column: 17
          },
          end: {
            line: 415,
            column: 18
          }
        },
        loc: {
          start: {
            line: 416,
            column: 4
          },
          end: {
            line: 416,
            column: 57
          }
        },
        line: 416
      },
      "22": {
        name: "(anonymous_22)",
        decl: {
          start: {
            line: 416,
            column: 15
          },
          end: {
            line: 416,
            column: 16
          }
        },
        loc: {
          start: {
            line: 416,
            column: 23
          },
          end: {
            line: 416,
            column: 56
          }
        },
        line: 416
      },
      "23": {
        name: "(anonymous_23)",
        decl: {
          start: {
            line: 427,
            column: 7
          },
          end: {
            line: 427,
            column: 8
          }
        },
        loc: {
          start: {
            line: 427,
            column: 25
          },
          end: {
            line: 435,
            column: 3
          }
        },
        line: 427
      },
      "24": {
        name: "(anonymous_24)",
        decl: {
          start: {
            line: 443,
            column: 18
          },
          end: {
            line: 443,
            column: 19
          }
        },
        loc: {
          start: {
            line: 443,
            column: 61
          },
          end: {
            line: 450,
            column: 3
          }
        },
        line: 443
      },
      "25": {
        name: "(anonymous_25)",
        decl: {
          start: {
            line: 462,
            column: 7
          },
          end: {
            line: 462,
            column: 8
          }
        },
        loc: {
          start: {
            line: 462,
            column: 43
          },
          end: {
            line: 474,
            column: 3
          }
        },
        line: 462
      },
      "26": {
        name: "(anonymous_26)",
        decl: {
          start: {
            line: 465,
            column: 53
          },
          end: {
            line: 465,
            column: 54
          }
        },
        loc: {
          start: {
            line: 466,
            column: 8
          },
          end: {
            line: 466,
            column: 47
          }
        },
        line: 466
      },
      "27": {
        name: "(anonymous_27)",
        decl: {
          start: {
            line: 470,
            column: 6
          },
          end: {
            line: 470,
            column: 7
          }
        },
        loc: {
          start: {
            line: 470,
            column: 15
          },
          end: {
            line: 470,
            column: 45
          }
        },
        line: 470
      },
      "28": {
        name: "(anonymous_28)",
        decl: {
          start: {
            line: 482,
            column: 18
          },
          end: {
            line: 482,
            column: 19
          }
        },
        loc: {
          start: {
            line: 482,
            column: 56
          },
          end: {
            line: 490,
            column: 3
          }
        },
        line: 482
      },
      "29": {
        name: "(anonymous_29)",
        decl: {
          start: {
            line: 485,
            column: 54
          },
          end: {
            line: 485,
            column: 55
          }
        },
        loc: {
          start: {
            line: 486,
            column: 8
          },
          end: {
            line: 486,
            column: 77
          }
        },
        line: 486
      },
      "30": {
        name: "(anonymous_30)",
        decl: {
          start: {
            line: 501,
            column: 7
          },
          end: {
            line: 501,
            column: 8
          }
        },
        loc: {
          start: {
            line: 501,
            column: 25
          },
          end: {
            line: 513,
            column: 3
          }
        },
        line: 501
      },
      "31": {
        name: "(anonymous_31)",
        decl: {
          start: {
            line: 521,
            column: 18
          },
          end: {
            line: 521,
            column: 19
          }
        },
        loc: {
          start: {
            line: 521,
            column: 60
          },
          end: {
            line: 532,
            column: 3
          }
        },
        line: 521
      },
      "32": {
        name: "(anonymous_32)",
        decl: {
          start: {
            line: 543,
            column: 7
          },
          end: {
            line: 543,
            column: 8
          }
        },
        loc: {
          start: {
            line: 543,
            column: 25
          },
          end: {
            line: 599,
            column: 3
          }
        },
        line: 543
      },
      "33": {
        name: "(anonymous_33)",
        decl: {
          start: {
            line: 562,
            column: 65
          },
          end: {
            line: 562,
            column: 66
          }
        },
        loc: {
          start: {
            line: 563,
            column: 6
          },
          end: {
            line: 563,
            column: 60
          }
        },
        line: 563
      },
      "34": {
        name: "(anonymous_34)",
        decl: {
          start: {
            line: 566,
            column: 50
          },
          end: {
            line: 566,
            column: 51
          }
        },
        loc: {
          start: {
            line: 566,
            column: 59
          },
          end: {
            line: 566,
            column: 75
          }
        },
        line: 566
      },
      "35": {
        name: "(anonymous_35)",
        decl: {
          start: {
            line: 567,
            column: 59
          },
          end: {
            line: 567,
            column: 60
          }
        },
        loc: {
          start: {
            line: 568,
            column: 6
          },
          end: {
            line: 568,
            column: 59
          }
        },
        line: 568
      },
      "36": {
        name: "(anonymous_36)",
        decl: {
          start: {
            line: 571,
            column: 57
          },
          end: {
            line: 571,
            column: 58
          }
        },
        loc: {
          start: {
            line: 572,
            column: 6
          },
          end: {
            line: 572,
            column: 50
          }
        },
        line: 572
      },
      "37": {
        name: "(anonymous_37)",
        decl: {
          start: {
            line: 576,
            column: 6
          },
          end: {
            line: 576,
            column: 7
          }
        },
        loc: {
          start: {
            line: 578,
            column: 8
          },
          end: {
            line: 578,
            column: 49
          }
        },
        line: 578
      },
      "38": {
        name: "(anonymous_38)",
        decl: {
          start: {
            line: 581,
            column: 61
          },
          end: {
            line: 581,
            column: 62
          }
        },
        loc: {
          start: {
            line: 582,
            column: 6
          },
          end: {
            line: 582,
            column: 43
          }
        },
        line: 582
      },
      "39": {
        name: "(anonymous_39)",
        decl: {
          start: {
            line: 594,
            column: 56
          },
          end: {
            line: 594,
            column: 57
          }
        },
        loc: {
          start: {
            line: 594,
            column: 65
          },
          end: {
            line: 594,
            column: 95
          }
        },
        line: 594
      },
      "40": {
        name: "(anonymous_40)",
        decl: {
          start: {
            line: 607,
            column: 18
          },
          end: {
            line: 607,
            column: 19
          }
        },
        loc: {
          start: {
            line: 607,
            column: 58
          },
          end: {
            line: 661,
            column: 3
          }
        },
        line: 607
      },
      "41": {
        name: "(anonymous_41)",
        decl: {
          start: {
            line: 620,
            column: 71
          },
          end: {
            line: 620,
            column: 72
          }
        },
        loc: {
          start: {
            line: 621,
            column: 6
          },
          end: {
            line: 621,
            column: 93
          }
        },
        line: 621
      },
      "42": {
        name: "(anonymous_42)",
        decl: {
          start: {
            line: 625,
            column: 65
          },
          end: {
            line: 625,
            column: 66
          }
        },
        loc: {
          start: {
            line: 626,
            column: 6
          },
          end: {
            line: 626,
            column: 71
          }
        },
        line: 626
      },
      "43": {
        name: "(anonymous_43)",
        decl: {
          start: {
            line: 630,
            column: 63
          },
          end: {
            line: 630,
            column: 64
          }
        },
        loc: {
          start: {
            line: 631,
            column: 6
          },
          end: {
            line: 631,
            column: 80
          }
        },
        line: 631
      },
      "44": {
        name: "(anonymous_44)",
        decl: {
          start: {
            line: 636,
            column: 6
          },
          end: {
            line: 636,
            column: 7
          }
        },
        loc: {
          start: {
            line: 638,
            column: 8
          },
          end: {
            line: 638,
            column: 79
          }
        },
        line: 638
      },
      "45": {
        name: "(anonymous_45)",
        decl: {
          start: {
            line: 643,
            column: 67
          },
          end: {
            line: 643,
            column: 68
          }
        },
        loc: {
          start: {
            line: 644,
            column: 6
          },
          end: {
            line: 644,
            column: 73
          }
        },
        line: 644
      },
      "46": {
        name: "(anonymous_46)",
        decl: {
          start: {
            line: 648,
            column: 61
          },
          end: {
            line: 648,
            column: 62
          }
        },
        loc: {
          start: {
            line: 649,
            column: 6
          },
          end: {
            line: 649,
            column: 67
          }
        },
        line: 649
      },
      "47": {
        name: "(anonymous_47)",
        decl: {
          start: {
            line: 665,
            column: 11
          },
          end: {
            line: 665,
            column: 12
          }
        },
        loc: {
          start: {
            line: 665,
            column: 22
          },
          end: {
            line: 665,
            column: 110
          }
        },
        line: 665
      },
      "48": {
        name: "(anonymous_48)",
        decl: {
          start: {
            line: 667,
            column: 12
          },
          end: {
            line: 667,
            column: 13
          }
        },
        loc: {
          start: {
            line: 667,
            column: 44
          },
          end: {
            line: 680,
            column: 3
          }
        },
        line: 667
      },
      "49": {
        name: "(anonymous_49)",
        decl: {
          start: {
            line: 682,
            column: 11
          },
          end: {
            line: 682,
            column: 12
          }
        },
        loc: {
          start: {
            line: 682,
            column: 22
          },
          end: {
            line: 682,
            column: 34
          }
        },
        line: 682
      },
      "50": {
        name: "(anonymous_50)",
        decl: {
          start: {
            line: 687,
            column: 13
          },
          end: {
            line: 687,
            column: 14
          }
        },
        loc: {
          start: {
            line: 687,
            column: 24
          },
          end: {
            line: 687,
            column: 69
          }
        },
        line: 687
      },
      "51": {
        name: "(anonymous_51)",
        decl: {
          start: {
            line: 696,
            column: 18
          },
          end: {
            line: 696,
            column: 19
          }
        },
        loc: {
          start: {
            line: 696,
            column: 40
          },
          end: {
            line: 706,
            column: 3
          }
        },
        line: 696
      },
      "52": {
        name: "(anonymous_52)",
        decl: {
          start: {
            line: 700,
            column: 30
          },
          end: {
            line: 700,
            column: 31
          }
        },
        loc: {
          start: {
            line: 700,
            column: 44
          },
          end: {
            line: 700,
            column: 82
          }
        },
        line: 700
      },
      "53": {
        name: "(anonymous_53)",
        decl: {
          start: {
            line: 708,
            column: 18
          },
          end: {
            line: 708,
            column: 19
          }
        },
        loc: {
          start: {
            line: 708,
            column: 29
          },
          end: {
            line: 720,
            column: 3
          }
        },
        line: 708
      },
      "54": {
        name: "(anonymous_54)",
        decl: {
          start: {
            line: 709,
            column: 23
          },
          end: {
            line: 709,
            column: 24
          }
        },
        loc: {
          start: {
            line: 709,
            column: 30
          },
          end: {
            line: 709,
            column: 50
          }
        },
        line: 709
      },
      "55": {
        name: "(anonymous_55)",
        decl: {
          start: {
            line: 726,
            column: 17
          },
          end: {
            line: 726,
            column: 18
          }
        },
        loc: {
          start: {
            line: 726,
            column: 28
          },
          end: {
            line: 729,
            column: 3
          }
        },
        line: 726
      },
      "56": {
        name: "(anonymous_56)",
        decl: {
          start: {
            line: 731,
            column: 19
          },
          end: {
            line: 731,
            column: 20
          }
        },
        loc: {
          start: {
            line: 731,
            column: 45
          },
          end: {
            line: 737,
            column: 3
          }
        },
        line: 731
      },
      "57": {
        name: "(anonymous_57)",
        decl: {
          start: {
            line: 733,
            column: 50
          },
          end: {
            line: 733,
            column: 51
          }
        },
        loc: {
          start: {
            line: 733,
            column: 66
          },
          end: {
            line: 736,
            column: 5
          }
        },
        line: 733
      },
      "58": {
        name: "(anonymous_58)",
        decl: {
          start: {
            line: 739,
            column: 18
          },
          end: {
            line: 739,
            column: 19
          }
        },
        loc: {
          start: {
            line: 739,
            column: 29
          },
          end: {
            line: 739,
            column: 66
          }
        },
        line: 739
      },
      "59": {
        name: "(anonymous_59)",
        decl: {
          start: {
            line: 751,
            column: 7
          },
          end: {
            line: 751,
            column: 8
          }
        },
        loc: {
          start: {
            line: 751,
            column: 25
          },
          end: {
            line: 757,
            column: 3
          }
        },
        line: 751
      },
      "60": {
        name: "(anonymous_60)",
        decl: {
          start: {
            line: 762,
            column: 18
          },
          end: {
            line: 762,
            column: 19
          }
        },
        loc: {
          start: {
            line: 762,
            column: 55
          },
          end: {
            line: 769,
            column: 3
          }
        },
        line: 762
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 9,
            column: 2
          },
          end: {
            line: 9,
            column: 89
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 9,
            column: 2
          },
          end: {
            line: 9,
            column: 9
          }
        }, {
          start: {
            line: 9,
            column: 14
          },
          end: {
            line: 9,
            column: 31
          }
        }, {
          start: {
            line: 9,
            column: 35
          },
          end: {
            line: 9,
            column: 59
          }
        }, {
          start: {
            line: 9,
            column: 63
          },
          end: {
            line: 9,
            column: 88
          }
        }],
        line: 9
      },
      "1": {
        loc: {
          start: {
            line: 22,
            column: 22
          },
          end: {
            line: 22,
            column: 52
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 22,
            column: 22
          },
          end: {
            line: 22,
            column: 46
          }
        }, {
          start: {
            line: 22,
            column: 50
          },
          end: {
            line: 22,
            column: 52
          }
        }],
        line: 22
      },
      "2": {
        loc: {
          start: {
            line: 132,
            column: 20
          },
          end: {
            line: 132,
            column: 63
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 132,
            column: 20
          },
          end: {
            line: 132,
            column: 37
          }
        }, {
          start: {
            line: 132,
            column: 41
          },
          end: {
            line: 132,
            column: 63
          }
        }],
        line: 132
      },
      "3": {
        loc: {
          start: {
            line: 137,
            column: 16
          },
          end: {
            line: 137,
            column: 69
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 137,
            column: 16
          },
          end: {
            line: 137,
            column: 29
          }
        }, {
          start: {
            line: 137,
            column: 33
          },
          end: {
            line: 137,
            column: 69
          }
        }],
        line: 137
      },
      "4": {
        loc: {
          start: {
            line: 138,
            column: 20
          },
          end: {
            line: 138,
            column: 81
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 138,
            column: 20
          },
          end: {
            line: 138,
            column: 37
          }
        }, {
          start: {
            line: 138,
            column: 41
          },
          end: {
            line: 138,
            column: 81
          }
        }],
        line: 138
      },
      "5": {
        loc: {
          start: {
            line: 139,
            column: 12
          },
          end: {
            line: 139,
            column: 57
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 139,
            column: 12
          },
          end: {
            line: 139,
            column: 21
          }
        }, {
          start: {
            line: 139,
            column: 25
          },
          end: {
            line: 139,
            column: 57
          }
        }],
        line: 139
      },
      "6": {
        loc: {
          start: {
            line: 143,
            column: 8
          },
          end: {
            line: 144,
            column: 81
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 143,
            column: 8
          },
          end: {
            line: 143,
            column: 28
          }
        }, {
          start: {
            line: 144,
            column: 9
          },
          end: {
            line: 144,
            column: 39
          }
        }, {
          start: {
            line: 144,
            column: 43
          },
          end: {
            line: 144,
            column: 80
          }
        }],
        line: 143
      },
      "7": {
        loc: {
          start: {
            line: 157,
            column: 20
          },
          end: {
            line: 157,
            column: 63
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 157,
            column: 20
          },
          end: {
            line: 157,
            column: 37
          }
        }, {
          start: {
            line: 157,
            column: 41
          },
          end: {
            line: 157,
            column: 63
          }
        }],
        line: 157
      },
      "8": {
        loc: {
          start: {
            line: 168,
            column: 8
          },
          end: {
            line: 169,
            column: 81
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 168,
            column: 8
          },
          end: {
            line: 168,
            column: 28
          }
        }, {
          start: {
            line: 169,
            column: 9
          },
          end: {
            line: 169,
            column: 39
          }
        }, {
          start: {
            line: 169,
            column: 43
          },
          end: {
            line: 169,
            column: 80
          }
        }],
        line: 168
      },
      "9": {
        loc: {
          start: {
            line: 190,
            column: 4
          },
          end: {
            line: 192,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 190,
            column: 4
          },
          end: {
            line: 192,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 190
      },
      "10": {
        loc: {
          start: {
            line: 198,
            column: 20
          },
          end: {
            line: 198,
            column: 63
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 198,
            column: 20
          },
          end: {
            line: 198,
            column: 37
          }
        }, {
          start: {
            line: 198,
            column: 41
          },
          end: {
            line: 198,
            column: 63
          }
        }],
        line: 198
      },
      "11": {
        loc: {
          start: {
            line: 207,
            column: 16
          },
          end: {
            line: 207,
            column: 69
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 207,
            column: 16
          },
          end: {
            line: 207,
            column: 29
          }
        }, {
          start: {
            line: 207,
            column: 33
          },
          end: {
            line: 207,
            column: 69
          }
        }],
        line: 207
      },
      "12": {
        loc: {
          start: {
            line: 208,
            column: 20
          },
          end: {
            line: 208,
            column: 81
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 208,
            column: 20
          },
          end: {
            line: 208,
            column: 37
          }
        }, {
          start: {
            line: 208,
            column: 41
          },
          end: {
            line: 208,
            column: 81
          }
        }],
        line: 208
      },
      "13": {
        loc: {
          start: {
            line: 212,
            column: 12
          },
          end: {
            line: 212,
            column: 76
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 212,
            column: 12
          },
          end: {
            line: 212,
            column: 21
          }
        }, {
          start: {
            line: 212,
            column: 26
          },
          end: {
            line: 212,
            column: 45
          }
        }, {
          start: {
            line: 212,
            column: 49
          },
          end: {
            line: 212,
            column: 75
          }
        }],
        line: 212
      },
      "14": {
        loc: {
          start: {
            line: 217,
            column: 4
          },
          end: {
            line: 223,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 217,
            column: 4
          },
          end: {
            line: 223,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 217
      },
      "15": {
        loc: {
          start: {
            line: 217,
            column: 8
          },
          end: {
            line: 217,
            column: 45
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 217,
            column: 8
          },
          end: {
            line: 217,
            column: 19
          }
        }, {
          start: {
            line: 217,
            column: 23
          },
          end: {
            line: 217,
            column: 45
          }
        }],
        line: 217
      },
      "16": {
        loc: {
          start: {
            line: 238,
            column: 20
          },
          end: {
            line: 238,
            column: 63
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 238,
            column: 20
          },
          end: {
            line: 238,
            column: 37
          }
        }, {
          start: {
            line: 238,
            column: 41
          },
          end: {
            line: 238,
            column: 63
          }
        }],
        line: 238
      },
      "17": {
        loc: {
          start: {
            line: 276,
            column: 4
          },
          end: {
            line: 278,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 276,
            column: 4
          },
          end: {
            line: 278,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 276
      },
      "18": {
        loc: {
          start: {
            line: 279,
            column: 4
          },
          end: {
            line: 330,
            column: 5
          }
        },
        type: "switch",
        locations: [{
          start: {
            line: 280,
            column: 6
          },
          end: {
            line: 287,
            column: 10
          }
        }, {
          start: {
            line: 288,
            column: 6
          },
          end: {
            line: 292,
            column: 20
          }
        }, {
          start: {
            line: 293,
            column: 6
          },
          end: {
            line: 297,
            column: 20
          }
        }, {
          start: {
            line: 298,
            column: 6
          },
          end: {
            line: 302,
            column: 20
          }
        }, {
          start: {
            line: 303,
            column: 6
          },
          end: {
            line: 307,
            column: 20
          }
        }, {
          start: {
            line: 308,
            column: 6
          },
          end: {
            line: 312,
            column: 20
          }
        }, {
          start: {
            line: 313,
            column: 6
          },
          end: {
            line: 317,
            column: 20
          }
        }, {
          start: {
            line: 318,
            column: 6
          },
          end: {
            line: 322,
            column: 20
          }
        }, {
          start: {
            line: 323,
            column: 6
          },
          end: {
            line: 327,
            column: 20
          }
        }, {
          start: {
            line: 328,
            column: 6
          },
          end: {
            line: 329,
            column: 20
          }
        }],
        line: 279
      },
      "19": {
        loc: {
          start: {
            line: 285,
            column: 10
          },
          end: {
            line: 286,
            column: 75
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 285,
            column: 10
          },
          end: {
            line: 285,
            column: 77
          }
        }, {
          start: {
            line: 286,
            column: 10
          },
          end: {
            line: 286,
            column: 75
          }
        }],
        line: 285
      },
      "20": {
        loc: {
          start: {
            line: 289,
            column: 8
          },
          end: {
            line: 291,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 289,
            column: 8
          },
          end: {
            line: 291,
            column: 9
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 289
      },
      "21": {
        loc: {
          start: {
            line: 294,
            column: 8
          },
          end: {
            line: 296,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 294,
            column: 8
          },
          end: {
            line: 296,
            column: 9
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 294
      },
      "22": {
        loc: {
          start: {
            line: 299,
            column: 8
          },
          end: {
            line: 301,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 299,
            column: 8
          },
          end: {
            line: 301,
            column: 9
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 299
      },
      "23": {
        loc: {
          start: {
            line: 304,
            column: 8
          },
          end: {
            line: 306,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 304,
            column: 8
          },
          end: {
            line: 306,
            column: 9
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 304
      },
      "24": {
        loc: {
          start: {
            line: 309,
            column: 8
          },
          end: {
            line: 311,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 309,
            column: 8
          },
          end: {
            line: 311,
            column: 9
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 309
      },
      "25": {
        loc: {
          start: {
            line: 314,
            column: 8
          },
          end: {
            line: 316,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 314,
            column: 8
          },
          end: {
            line: 316,
            column: 9
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 314
      },
      "26": {
        loc: {
          start: {
            line: 319,
            column: 8
          },
          end: {
            line: 321,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 319,
            column: 8
          },
          end: {
            line: 321,
            column: 9
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 319
      },
      "27": {
        loc: {
          start: {
            line: 324,
            column: 8
          },
          end: {
            line: 326,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 324,
            column: 8
          },
          end: {
            line: 326,
            column: 9
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 324
      },
      "28": {
        loc: {
          start: {
            line: 324,
            column: 12
          },
          end: {
            line: 324,
            column: 60
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 324,
            column: 12
          },
          end: {
            line: 324,
            column: 30
          }
        }, {
          start: {
            line: 324,
            column: 34
          },
          end: {
            line: 324,
            column: 60
          }
        }],
        line: 324
      },
      "29": {
        loc: {
          start: {
            line: 344,
            column: 4
          },
          end: {
            line: 359,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 344,
            column: 4
          },
          end: {
            line: 359,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 344
      },
      "30": {
        loc: {
          start: {
            line: 347,
            column: 6
          },
          end: {
            line: 349,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 347,
            column: 6
          },
          end: {
            line: 349,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 347
      },
      "31": {
        loc: {
          start: {
            line: 350,
            column: 6
          },
          end: {
            line: 352,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 350,
            column: 6
          },
          end: {
            line: 352,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 350
      },
      "32": {
        loc: {
          start: {
            line: 354,
            column: 6
          },
          end: {
            line: 358,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 354,
            column: 6
          },
          end: {
            line: 358,
            column: 7
          }
        }, {
          start: {
            line: 356,
            column: 13
          },
          end: {
            line: 358,
            column: 7
          }
        }],
        line: 354
      },
      "33": {
        loc: {
          start: {
            line: 355,
            column: 21
          },
          end: {
            line: 355,
            column: 39
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 355,
            column: 33
          },
          end: {
            line: 355,
            column: 34
          }
        }, {
          start: {
            line: 355,
            column: 37
          },
          end: {
            line: 355,
            column: 39
          }
        }],
        line: 355
      },
      "34": {
        loc: {
          start: {
            line: 356,
            column: 13
          },
          end: {
            line: 358,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 356,
            column: 13
          },
          end: {
            line: 358,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 356
      },
      "35": {
        loc: {
          start: {
            line: 357,
            column: 21
          },
          end: {
            line: 357,
            column: 39
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 357,
            column: 33
          },
          end: {
            line: 357,
            column: 35
          }
        }, {
          start: {
            line: 357,
            column: 38
          },
          end: {
            line: 357,
            column: 39
          }
        }],
        line: 357
      },
      "36": {
        loc: {
          start: {
            line: 364,
            column: 4
          },
          end: {
            line: 379,
            column: 5
          }
        },
        type: "switch",
        locations: [{
          start: {
            line: 365,
            column: 6
          },
          end: {
            line: 366,
            column: 22
          }
        }, {
          start: {
            line: 367,
            column: 6
          },
          end: {
            line: 368,
            column: 27
          }
        }, {
          start: {
            line: 369,
            column: 6
          },
          end: {
            line: 370,
            column: 29
          }
        }, {
          start: {
            line: 371,
            column: 6
          },
          end: {
            line: 372,
            column: 23
          }
        }, {
          start: {
            line: 373,
            column: 6
          },
          end: {
            line: 374,
            column: 27
          }
        }, {
          start: {
            line: 375,
            column: 6
          },
          end: {
            line: 376,
            column: 30
          }
        }, {
          start: {
            line: 377,
            column: 6
          },
          end: {
            line: 378,
            column: 20
          }
        }],
        line: 364
      },
      "37": {
        loc: {
          start: {
            line: 397,
            column: 8
          },
          end: {
            line: 402,
            column: 75
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 397,
            column: 9
          },
          end: {
            line: 397,
            column: 25
          }
        }, {
          start: {
            line: 397,
            column: 29
          },
          end: {
            line: 397,
            column: 86
          }
        }, {
          start: {
            line: 398,
            column: 9
          },
          end: {
            line: 398,
            column: 25
          }
        }, {
          start: {
            line: 398,
            column: 29
          },
          end: {
            line: 398,
            column: 86
          }
        }, {
          start: {
            line: 399,
            column: 9
          },
          end: {
            line: 399,
            column: 26
          }
        }, {
          start: {
            line: 399,
            column: 30
          },
          end: {
            line: 399,
            column: 88
          }
        }, {
          start: {
            line: 400,
            column: 9
          },
          end: {
            line: 400,
            column: 25
          }
        }, {
          start: {
            line: 400,
            column: 29
          },
          end: {
            line: 400,
            column: 86
          }
        }, {
          start: {
            line: 401,
            column: 9
          },
          end: {
            line: 401,
            column: 32
          }
        }, {
          start: {
            line: 402,
            column: 10
          },
          end: {
            line: 402,
            column: 74
          }
        }],
        line: 397
      },
      "38": {
        loc: {
          start: {
            line: 432,
            column: 12
          },
          end: {
            line: 432,
            column: 76
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 432,
            column: 12
          },
          end: {
            line: 432,
            column: 21
          }
        }, {
          start: {
            line: 432,
            column: 26
          },
          end: {
            line: 432,
            column: 45
          }
        }, {
          start: {
            line: 432,
            column: 49
          },
          end: {
            line: 432,
            column: 75
          }
        }],
        line: 432
      },
      "39": {
        loc: {
          start: {
            line: 464,
            column: 4
          },
          end: {
            line: 468,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 464,
            column: 4
          },
          end: {
            line: 468,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 464
      },
      "40": {
        loc: {
          start: {
            line: 464,
            column: 8
          },
          end: {
            line: 464,
            column: 55
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 464,
            column: 8
          },
          end: {
            line: 464,
            column: 24
          }
        }, {
          start: {
            line: 464,
            column: 28
          },
          end: {
            line: 464,
            column: 55
          }
        }],
        line: 464
      },
      "41": {
        loc: {
          start: {
            line: 484,
            column: 4
          },
          end: {
            line: 488,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 484,
            column: 4
          },
          end: {
            line: 488,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 484
      },
      "42": {
        loc: {
          start: {
            line: 484,
            column: 8
          },
          end: {
            line: 484,
            column: 57
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 484,
            column: 8
          },
          end: {
            line: 484,
            column: 25
          }
        }, {
          start: {
            line: 484,
            column: 29
          },
          end: {
            line: 484,
            column: 57
          }
        }],
        line: 484
      },
      "43": {
        loc: {
          start: {
            line: 557,
            column: 18
          },
          end: {
            line: 560,
            column: 7
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 557,
            column: 18
          },
          end: {
            line: 557,
            column: 34
          }
        }, {
          start: {
            line: 557,
            column: 38
          },
          end: {
            line: 560,
            column: 7
          }
        }],
        line: 557
      },
      "44": {
        loc: {
          start: {
            line: 585,
            column: 4
          },
          end: {
            line: 591,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 585,
            column: 4
          },
          end: {
            line: 591,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 585
      },
      "45": {
        loc: {
          start: {
            line: 593,
            column: 4
          },
          end: {
            line: 596,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 593,
            column: 4
          },
          end: {
            line: 596,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 593
      },
      "46": {
        loc: {
          start: {
            line: 652,
            column: 4
          },
          end: {
            line: 658,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 652,
            column: 4
          },
          end: {
            line: 658,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 652
      },
      "47": {
        loc: {
          start: {
            line: 665,
            column: 22
          },
          end: {
            line: 665,
            column: 110
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 665,
            column: 22
          },
          end: {
            line: 665,
            column: 61
          }
        }, {
          start: {
            line: 665,
            column: 65
          },
          end: {
            line: 665,
            column: 110
          }
        }],
        line: 665
      },
      "48": {
        loc: {
          start: {
            line: 672,
            column: 4
          },
          end: {
            line: 674,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 672,
            column: 4
          },
          end: {
            line: 674,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 672
      },
      "49": {
        loc: {
          start: {
            line: 676,
            column: 18
          },
          end: {
            line: 676,
            column: 63
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 676,
            column: 18
          },
          end: {
            line: 676,
            column: 57
          }
        }, {
          start: {
            line: 676,
            column: 61
          },
          end: {
            line: 676,
            column: 63
          }
        }],
        line: 676
      },
      "50": {
        loc: {
          start: {
            line: 677,
            column: 18
          },
          end: {
            line: 677,
            column: 63
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 677,
            column: 18
          },
          end: {
            line: 677,
            column: 57
          }
        }, {
          start: {
            line: 677,
            column: 61
          },
          end: {
            line: 677,
            column: 63
          }
        }],
        line: 677
      },
      "51": {
        loc: {
          start: {
            line: 687,
            column: 24
          },
          end: {
            line: 687,
            column: 69
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 687,
            column: 24
          },
          end: {
            line: 687,
            column: 39
          }
        }, {
          start: {
            line: 687,
            column: 43
          },
          end: {
            line: 687,
            column: 69
          }
        }],
        line: 687
      },
      "52": {
        loc: {
          start: {
            line: 699,
            column: 4
          },
          end: {
            line: 704,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 699,
            column: 4
          },
          end: {
            line: 704,
            column: 5
          }
        }, {
          start: {
            line: 701,
            column: 11
          },
          end: {
            line: 704,
            column: 5
          }
        }],
        line: 699
      },
      "53": {
        loc: {
          start: {
            line: 701,
            column: 11
          },
          end: {
            line: 704,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 701,
            column: 11
          },
          end: {
            line: 704,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 701
      },
      "54": {
        loc: {
          start: {
            line: 709,
            column: 30
          },
          end: {
            line: 709,
            column: 50
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 709,
            column: 30
          },
          end: {
            line: 709,
            column: 33
          }
        }, {
          start: {
            line: 709,
            column: 37
          },
          end: {
            line: 709,
            column: 50
          }
        }],
        line: 709
      },
      "55": {
        loc: {
          start: {
            line: 710,
            column: 4
          },
          end: {
            line: 712,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 710,
            column: 4
          },
          end: {
            line: 712,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 710
      },
      "56": {
        loc: {
          start: {
            line: 713,
            column: 4
          },
          end: {
            line: 715,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 713,
            column: 4
          },
          end: {
            line: 715,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 713
      },
      "57": {
        loc: {
          start: {
            line: 716,
            column: 4
          },
          end: {
            line: 718,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 716,
            column: 4
          },
          end: {
            line: 718,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 716
      },
      "58": {
        loc: {
          start: {
            line: 728,
            column: 11
          },
          end: {
            line: 728,
            column: 64
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 728,
            column: 38
          },
          end: {
            line: 728,
            column: 52
          }
        }, {
          start: {
            line: 728,
            column: 55
          },
          end: {
            line: 728,
            column: 64
          }
        }],
        line: 728
      },
      "59": {
        loc: {
          start: {
            line: 739,
            column: 29
          },
          end: {
            line: 739,
            column: 66
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 739,
            column: 44
          },
          end: {
            line: 739,
            column: 61
          }
        }, {
          start: {
            line: 739,
            column: 64
          },
          end: {
            line: 739,
            column: 66
          }
        }],
        line: 739
      },
      "60": {
        loc: {
          start: {
            line: 754,
            column: 22
          },
          end: {
            line: 754,
            column: 90
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 754,
            column: 22
          },
          end: {
            line: 754,
            column: 41
          }
        }, {
          start: {
            line: 754,
            column: 45
          },
          end: {
            line: 754,
            column: 90
          }
        }],
        line: 754
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0,
      "63": 0,
      "64": 0,
      "65": 0,
      "66": 0,
      "67": 0,
      "68": 0,
      "69": 0,
      "70": 0,
      "71": 0,
      "72": 0,
      "73": 0,
      "74": 0,
      "75": 0,
      "76": 0,
      "77": 0,
      "78": 0,
      "79": 0,
      "80": 0,
      "81": 0,
      "82": 0,
      "83": 0,
      "84": 0,
      "85": 0,
      "86": 0,
      "87": 0,
      "88": 0,
      "89": 0,
      "90": 0,
      "91": 0,
      "92": 0,
      "93": 0,
      "94": 0,
      "95": 0,
      "96": 0,
      "97": 0,
      "98": 0,
      "99": 0,
      "100": 0,
      "101": 0,
      "102": 0,
      "103": 0,
      "104": 0,
      "105": 0,
      "106": 0,
      "107": 0,
      "108": 0,
      "109": 0,
      "110": 0,
      "111": 0,
      "112": 0,
      "113": 0,
      "114": 0,
      "115": 0,
      "116": 0,
      "117": 0,
      "118": 0,
      "119": 0,
      "120": 0,
      "121": 0,
      "122": 0,
      "123": 0,
      "124": 0,
      "125": 0,
      "126": 0,
      "127": 0,
      "128": 0,
      "129": 0,
      "130": 0,
      "131": 0,
      "132": 0,
      "133": 0,
      "134": 0,
      "135": 0,
      "136": 0,
      "137": 0,
      "138": 0,
      "139": 0,
      "140": 0,
      "141": 0,
      "142": 0,
      "143": 0,
      "144": 0,
      "145": 0,
      "146": 0,
      "147": 0,
      "148": 0,
      "149": 0,
      "150": 0,
      "151": 0,
      "152": 0,
      "153": 0,
      "154": 0,
      "155": 0,
      "156": 0,
      "157": 0,
      "158": 0,
      "159": 0,
      "160": 0,
      "161": 0,
      "162": 0,
      "163": 0,
      "164": 0,
      "165": 0,
      "166": 0,
      "167": 0,
      "168": 0,
      "169": 0,
      "170": 0,
      "171": 0,
      "172": 0,
      "173": 0,
      "174": 0,
      "175": 0,
      "176": 0,
      "177": 0,
      "178": 0,
      "179": 0,
      "180": 0,
      "181": 0,
      "182": 0,
      "183": 0,
      "184": 0,
      "185": 0,
      "186": 0,
      "187": 0,
      "188": 0,
      "189": 0,
      "190": 0,
      "191": 0,
      "192": 0,
      "193": 0,
      "194": 0,
      "195": 0,
      "196": 0,
      "197": 0,
      "198": 0,
      "199": 0,
      "200": 0,
      "201": 0,
      "202": 0,
      "203": 0,
      "204": 0,
      "205": 0,
      "206": 0,
      "207": 0,
      "208": 0,
      "209": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0
    },
    b: {
      "0": [0, 0, 0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0, 0],
      "7": [0, 0],
      "8": [0, 0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0],
      "18": [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      "19": [0, 0],
      "20": [0, 0],
      "21": [0, 0],
      "22": [0, 0],
      "23": [0, 0],
      "24": [0, 0],
      "25": [0, 0],
      "26": [0, 0],
      "27": [0, 0],
      "28": [0, 0],
      "29": [0, 0],
      "30": [0, 0],
      "31": [0, 0],
      "32": [0, 0],
      "33": [0, 0],
      "34": [0, 0],
      "35": [0, 0],
      "36": [0, 0, 0, 0, 0, 0, 0],
      "37": [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      "38": [0, 0, 0],
      "39": [0, 0],
      "40": [0, 0],
      "41": [0, 0],
      "42": [0, 0],
      "43": [0, 0],
      "44": [0, 0],
      "45": [0, 0],
      "46": [0, 0],
      "47": [0, 0],
      "48": [0, 0],
      "49": [0, 0],
      "50": [0, 0],
      "51": [0, 0],
      "52": [0, 0],
      "53": [0, 0],
      "54": [0, 0],
      "55": [0, 0],
      "56": [0, 0],
      "57": [0, 0],
      "58": [0, 0],
      "59": [0, 0],
      "60": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "228761a7ec6bca6cf0de427602137a41f491fd21"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2lqxhfvlrd = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_2lqxhfvlrd();
function ownKeys(e, r) { var t = _Object$keys2(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
cov_2lqxhfvlrd().s[0]++;
var getName = function getName(rawName, language, defaultLanguage) {
  cov_2lqxhfvlrd().f[0]++;
  cov_2lqxhfvlrd().s[1]++;
  return (cov_2lqxhfvlrd().b[0][0]++, rawName) && ((cov_2lqxhfvlrd().b[0][1]++, rawName[language]) || (cov_2lqxhfvlrd().b[0][2]++, rawName[defaultLanguage]) || (cov_2lqxhfvlrd().b[0][3]++, (0, _values.default)(rawName)[0]));
};
var TariffModel = (cov_2lqxhfvlrd().s[2]++, {
  /**
   * This function is used to transform product data received by the server to product data that will be used in
   * the nucleo (state) and all the functional components
   * it assign the data and add the currencyCode inline
   * TODO : data about advantage not yet supported
   * @param {object} data, it is the value of price received by the server
   * @param {ConfigType} config, it is the nucleo config object
   * @returns TariffType
   */
  get: function get(data, config) {
    cov_2lqxhfvlrd().f[1]++;
    var audSubCat = (cov_2lqxhfvlrd().s[3]++, (cov_2lqxhfvlrd().b[1][0]++, data.audienceSubCategory) || (cov_2lqxhfvlrd().b[1][1]++, {}));
    var _ref = (cov_2lqxhfvlrd().s[4]++, config),
      language = _ref.language,
      defaultLanguage = _ref.defaultLanguage;
    cov_2lqxhfvlrd().s[5]++;
    return {
      price: {
        amount: data.amount,
        currencyCode: config.currencyCode
      },
      kind: audSubCat.audienceCategoryKind,
      code: audSubCat.code,
      description: audSubCat.description,
      id: audSubCat.id,
      // get the translated objects to avoid computing it everywhere, but keep all translations
      rawName: audSubCat.name,
      name: getName(audSubCat.name, language, defaultLanguage),
      rank: audSubCat.rank,
      maxQuantity: data.maxQuantity,
      minQuantity: data.minQuantity,
      priceLevelId: data.priceLevelId,
      rateTypeId: data.rateTypeId,
      availability: data.availability
    };
  },
  getPerformanceTariff: function getPerformanceTariff(data, config) {
    cov_2lqxhfvlrd().f[2]++;
    var tariff = (cov_2lqxhfvlrd().s[6]++, TariffModel.get(data, config));
    cov_2lqxhfvlrd().s[7]++;
    return _objectSpread(_objectSpread({}, tariff), {}, {
      seatCategoryId: data.seatCategoryId,
      seatCategoryName: data.seatCategoryName,
      seatCategoryRank: data.seatCategoryRank,
      seatCategoryBgColor: "#".concat(data.bgColor),
      seatCategoryTextColor: "#".concat(data.textColor)
    });
  },
  /**
   * Change the language of the tariff
   * @param {tariff} tariff, it is the value tariff in the state
   * @param {string} language, the first language to try to get
   * @param {string} defaultLanguage, the fallback language if not exist
   * @returns TariffType
   */
  changeLanguage: function changeLanguage(tariff, language, defaultLanguage) {
    cov_2lqxhfvlrd().f[3]++;
    cov_2lqxhfvlrd().s[8]++;
    return _objectSpread(_objectSpread({}, tariff), {}, {
      name: getName(tariff.rawName, language, defaultLanguage)
    });
  }
});
var TeamModel = exports.TeamModel = (cov_2lqxhfvlrd().s[9]++, {
  /**
   * This function is used to transform product data received by the server to product data that will be used in
   * the nucleo (state) and all the functional components
   * @param {object} data, it is the value of team received by the server
   * @param {ConfigType} config, it is the nucleo config object
   * @returns TeamType
   */
  get: function get(data, config) {
    cov_2lqxhfvlrd().f[4]++;
    var _ref2 = (cov_2lqxhfvlrd().s[10]++, config),
      language = _ref2.language,
      defaultLanguage = _ref2.defaultLanguage;
    var adaptedData = (cov_2lqxhfvlrd().s[11]++, {
      // get the translated objects to avoid computing it everywhere, but keep all translations
      rawName: data.name,
      name: getName(data.name, language, defaultLanguage)
    });
    cov_2lqxhfvlrd().s[12]++;
    return _objectSpread(_objectSpread({}, data), adaptedData);
  }
});
var SiteModel = exports.SiteModel = (cov_2lqxhfvlrd().s[13]++, {
  /**
   * This function is used to transform product data received by the server to product data that will be used in
   * the nucleo (state) and all the functional components
   * @param {object} data, it is the value of team received by the server
   * @param {ConfigType} config, it is the nucleo config object
   * @returns TeamType
   */
  get: function get(data, config) {
    cov_2lqxhfvlrd().f[5]++;
    var _ref3 = (cov_2lqxhfvlrd().s[14]++, config),
      language = _ref3.language,
      defaultLanguage = _ref3.defaultLanguage;
    var adaptedData = (cov_2lqxhfvlrd().s[15]++, {
      // get the translated objects to avoid computing it everywhere, but keep all translations
      rawName: data.name,
      name: getName(data.name, language, defaultLanguage)
    });
    cov_2lqxhfvlrd().s[16]++;
    return _objectSpread(_objectSpread({}, data), adaptedData);
  },
  changeLanguage: function changeLanguage(data, language, defaultLanguage) {
    cov_2lqxhfvlrd().f[6]++;
    var adaptedData = (cov_2lqxhfvlrd().s[17]++, {
      // get the translated objects to avoid computing it everywhere, but keep all translations
      name: getName(data.name, language, defaultLanguage)
    });
    cov_2lqxhfvlrd().s[18]++;
    return _objectSpread(_objectSpread({}, data), adaptedData);
  }
});
var HospitalitySessionModel = exports.HospitalitySessionModel = (cov_2lqxhfvlrd().s[19]++, {
  /**
   * This function is used to transform product data received by the server to product data that will be used in
   * the nucleo (state) and all the functional components
   * It needs the original productData to get the basic name
   * @param {object} data, it is the value of hospitality session received by the server
   * @param {object} productData, it is the value of product received by the server
   * @param {ConfigType} config, it is the nucleo config object
   * @returns PerformanceType
   */
  get: function get(data, config) {
    cov_2lqxhfvlrd().f[7]++;
    var _ref4 = (cov_2lqxhfvlrd().s[20]++, config),
      language = _ref4.language,
      defaultLanguage = _ref4.defaultLanguage;
    var adaptedData = (cov_2lqxhfvlrd().s[21]++, {
      // remove the specific performanceId property.
      id: data.id,
      // backward compatible, remove the availabilityLevel and put the availability instead
      availability: (cov_2lqxhfvlrd().b[2][0]++, data.availability) || (cov_2lqxhfvlrd().b[2][1]++, data.availabilityLevel),
      // get the translated objects to avoid computing it everywhere, but keep all translations
      rawName: data.name,
      name: getName(data.name, language, defaultLanguage),
      roundName: getName(data.roundName, language, defaultLanguage),
      hostTeam: (cov_2lqxhfvlrd().b[3][0]++, data.hostTeam) && (cov_2lqxhfvlrd().b[3][1]++, TeamModel.get(data.hostTeam, config)),
      opposingTeam: (cov_2lqxhfvlrd().b[4][0]++, data.opposingTeam) && (cov_2lqxhfvlrd().b[4][1]++, TeamModel.get(data.opposingTeam, config)),
      site: (cov_2lqxhfvlrd().b[5][0]++, data.site) && (cov_2lqxhfvlrd().b[5][1]++, SiteModel.get(data.site, config)),
      date: data.date,
      time: data.time,
      performanceKind: (cov_2lqxhfvlrd().b[6][0]++, data.performanceKind) && ((cov_2lqxhfvlrd().b[6][1]++, data.performanceKind[language]) || (cov_2lqxhfvlrd().b[6][2]++, data.performanceKind[defaultLanguage]))
    });
    cov_2lqxhfvlrd().s[22]++;
    return _objectSpread(_objectSpread({}, data), adaptedData);
  },
  /**
   * Get a language and return the performance with the new translation
   */
  changeLanguage: function changeLanguage(data, language, defaultLanguage) {
    cov_2lqxhfvlrd().f[8]++;
    var adaptedData = (cov_2lqxhfvlrd().s[23]++, {
      // remove the specific performanceId property.
      id: data.id,
      // backward compatible, remove the availabilityLevel and put the availability instead
      availability: (cov_2lqxhfvlrd().b[7][0]++, data.availability) || (cov_2lqxhfvlrd().b[7][1]++, data.availabilityLevel),
      // get the translated objects to avoid computing it everywhere, but keep all translations
      rawName: data.name,
      name: getName(data.name, language, defaultLanguage),
      roundName: getName(data.roundName, language, defaultLanguage),
      hostTeam: data.hostTeam,
      opposingTeam: data.opposingTeam,
      date: data.date,
      time: data.time,
      site: SiteModel.changeLanguage(data.site, language, defaultLanguage),
      performanceKind: (cov_2lqxhfvlrd().b[8][0]++, data.performanceKind) && ((cov_2lqxhfvlrd().b[8][1]++, data.performanceKind[language]) || (cov_2lqxhfvlrd().b[8][2]++, data.performanceKind[defaultLanguage]))
    });
    cov_2lqxhfvlrd().s[24]++;
    return _objectSpread(_objectSpread({}, data), adaptedData);
  }
});
var PerformanceModel = exports.PerformanceModel = (cov_2lqxhfvlrd().s[25]++, {
  /**
   * This function is used to transform product data received by the server to product data that will be used in
   * the nucleo (state) and all the functional components
   * It needs the original productData to get the basic name
   * @param {object} data, it is the value of performance received by the server
   * @param {object} productData, it is the value of product received by the server
   * @param {ConfigType} config, it is the nucleo config object
   * @returns PerformanceType
   */
  get: function get(data, productData, config) {
    cov_2lqxhfvlrd().f[9]++;
    var _ref5 = (cov_2lqxhfvlrd().s[26]++, config),
      language = _ref5.language,
      defaultLanguage = _ref5.defaultLanguage;
    var parsedName = (cov_2lqxhfvlrd().s[27]++, data.name);
    // If no performance name, get the product name
    cov_2lqxhfvlrd().s[28]++;
    if ((0, _keys.default)(parsedName).length === 0) {
      cov_2lqxhfvlrd().b[9][0]++;
      cov_2lqxhfvlrd().s[29]++;
      parsedName = productData.rawName;
    } else {
      cov_2lqxhfvlrd().b[9][1]++;
    }
    var adaptedData = (cov_2lqxhfvlrd().s[30]++, {
      // remove the specific performanceId property.
      id: data.performanceId,
      performanceId: undefined,
      // backward compatible, remove the availabilityLevel and put the availability instead
      availability: (cov_2lqxhfvlrd().b[10][0]++, data.availability) || (cov_2lqxhfvlrd().b[10][1]++, data.availabilityLevel),
      availabilityLevel: undefined,
      // get the translated objects to avoid computing it everywhere, but keep all translations
      rawName: parsedName,
      name: getName(parsedName, language, defaultLanguage),
      rawVenue: data.venue,
      venue: getName(data.venue, language, defaultLanguage),
      rawSubtitle: data.subtitle,
      subtitle: getName(data.subtitle, language, defaultLanguage),
      hostTeam: (cov_2lqxhfvlrd().b[11][0]++, data.hostTeam) && (cov_2lqxhfvlrd().b[11][1]++, TeamModel.get(data.hostTeam, config)),
      opposingTeam: (cov_2lqxhfvlrd().b[12][0]++, data.opposingTeam) && (cov_2lqxhfvlrd().b[12][1]++, TeamModel.get(data.opposingTeam, config)),
      rawDescription: data.perfDescription,
      description: getName(data.perfDescription, language, defaultLanguage),
      rawZone: data.zone,
      zone: (cov_2lqxhfvlrd().b[13][0]++, data.zone) && ((cov_2lqxhfvlrd().b[13][1]++, data.zone[language]) || (cov_2lqxhfvlrd().b[13][2]++, data.zone[defaultLanguage])),
      timeStart: data.start,
      timeEnd: data.end
    });
    cov_2lqxhfvlrd().s[31]++;
    if ((cov_2lqxhfvlrd().b[15][0]++, data.prices) && (cov_2lqxhfvlrd().b[15][1]++, data.prices.length > 0)) {
      cov_2lqxhfvlrd().b[14][0]++;
      cov_2lqxhfvlrd().s[32]++;
      adaptedData.tariffs = data.prices.map(function (price) {
        cov_2lqxhfvlrd().f[10]++;
        cov_2lqxhfvlrd().s[33]++;
        return TariffModel.getPerformanceTariff(price, config);
      });
      cov_2lqxhfvlrd().s[34]++;
      adaptedData.tariffsBySeatCat = (0, _groupBy.default)(adaptedData.tariffs, function (tariff) {
        cov_2lqxhfvlrd().f[11]++;
        cov_2lqxhfvlrd().s[35]++;
        return tariff.seatCategoryId;
      });
      cov_2lqxhfvlrd().s[36]++;
      adaptedData.prices = undefined;
    } else {
      cov_2lqxhfvlrd().b[14][1]++;
    }
    var result = (cov_2lqxhfvlrd().s[37]++, _objectSpread(_objectSpread({}, data), adaptedData));
    cov_2lqxhfvlrd().s[38]++;
    delete result.perfDescription;
    cov_2lqxhfvlrd().s[39]++;
    return result;
  },
  /**
   * Get a language and return the performance with the new translation
   */
  changeLanguage: function changeLanguage(data, productData, language, defaultLanguage) {
    cov_2lqxhfvlrd().f[12]++;
    var adaptedData = (cov_2lqxhfvlrd().s[40]++, {
      // remove the specific performanceId property.
      id: data.id,
      performanceId: data.performanceId,
      // backward compatible, remove the availabilityLevel and put the availability instead
      availability: (cov_2lqxhfvlrd().b[16][0]++, data.availability) || (cov_2lqxhfvlrd().b[16][1]++, data.availabilityLevel),
      availabilityLevel: undefined,
      // get the translated objects to avoid computing it everywhere, but keep all translations
      rawName: data.rawName,
      name: getName(data.rawName, language, defaultLanguage),
      rawVenue: data.rawVenue,
      venue: getName(data.rawVenue, language, defaultLanguage),
      rawSubtitle: data.rawSubtitle,
      subtitle: getName(data.rawSubtitle, language, defaultLanguage),
      hostTeam: data.hostTeam,
      opposingTeam: data.opposingTeam,
      rawDescription: data.rawDescription,
      description: getName(data.rawDescription, language, defaultLanguage),
      rawZone: data.rawZone,
      zone: getName(data.rawZone, language, defaultLanguage),
      timeStart: data.start,
      timeEnd: data.end,
      tariffs: data.tariffs
    });
    cov_2lqxhfvlrd().s[41]++;
    return _objectSpread(_objectSpread({}, data), adaptedData);
  },
  /**
   * Depending of the filter type, search inside the performance the
   * value of filter
   *
   * @param {object} typefilter, contant the type and the value of filter
   * @param  {object} contentProduct, contain the value of performace to filter
   *
   * @return true if the performance matches with the filter value
   */
  filterBy: function filterBy(filter, contentProduct) {
    cov_2lqxhfvlrd().f[13]++;
    var timeStart;
    var valueTimeStart;
    var valueTimeEnd;
    var _ref6 = (cov_2lqxhfvlrd().s[42]++, filter),
      typeFilter = _ref6.typeFilter,
      valueFilter = _ref6.valueFilter;
    var performance = (cov_2lqxhfvlrd().s[43]++, contentProduct.product.performances[0]);
    // If the filter has no value, no filter
    cov_2lqxhfvlrd().s[44]++;
    if (valueFilter === null) {
      cov_2lqxhfvlrd().b[17][0]++;
      cov_2lqxhfvlrd().s[45]++;
      return true;
    } else {
      cov_2lqxhfvlrd().b[17][1]++;
    }
    cov_2lqxhfvlrd().s[46]++;
    switch (typeFilter) {
      case 'calendar':
        cov_2lqxhfvlrd().b[18][0]++;
        cov_2lqxhfvlrd().s[47]++;
        timeStart = (0, _format.default)(new Date(performance.timeStart), 'YYYY-MM-DD');
        cov_2lqxhfvlrd().s[48]++;
        valueTimeStart = (0, _format.default)(new Date(valueFilter.startDate), 'YYYY-MM-DD');
        cov_2lqxhfvlrd().s[49]++;
        valueTimeEnd = (0, _format.default)(new Date(valueFilter.endDate), 'YYYY-MM-DD');
        cov_2lqxhfvlrd().s[50]++;
        return (cov_2lqxhfvlrd().b[19][0]++, new Date(timeStart).getTime() >= new Date(valueTimeStart).getTime()) && (cov_2lqxhfvlrd().b[19][1]++, new Date(timeStart).getTime() <= new Date(valueTimeEnd).getTime());
      case 'icons':
        cov_2lqxhfvlrd().b[18][1]++;
        cov_2lqxhfvlrd().s[51]++;
        if (valueFilter.length) {
          cov_2lqxhfvlrd().b[20][0]++;
          cov_2lqxhfvlrd().s[52]++;
          return (0, _findIndex.default)(valueFilter, function (item) {
            cov_2lqxhfvlrd().f[14]++;
            cov_2lqxhfvlrd().s[53]++;
            return item.name === performance.name;
          }) > -1;
        } else {
          cov_2lqxhfvlrd().b[20][1]++;
        }
        cov_2lqxhfvlrd().s[54]++;
        return true;
      case 'list':
        cov_2lqxhfvlrd().b[18][2]++;
        cov_2lqxhfvlrd().s[55]++;
        if (valueFilter.length) {
          cov_2lqxhfvlrd().b[21][0]++;
          cov_2lqxhfvlrd().s[56]++;
          return (0, _findIndex.default)(valueFilter, function (item) {
            cov_2lqxhfvlrd().f[15]++;
            cov_2lqxhfvlrd().s[57]++;
            return item.label === performance.zone;
          }) > -1;
        } else {
          cov_2lqxhfvlrd().b[21][1]++;
        }
        cov_2lqxhfvlrd().s[58]++;
        return true;
      case 'freeText':
        cov_2lqxhfvlrd().b[18][3]++;
        cov_2lqxhfvlrd().s[59]++;
        if (valueFilter.length) {
          cov_2lqxhfvlrd().b[22][0]++;
          cov_2lqxhfvlrd().s[60]++;
          return PerformanceModel.searchPerformance(valueFilter, performance);
        } else {
          cov_2lqxhfvlrd().b[22][1]++;
        }
        cov_2lqxhfvlrd().s[61]++;
        return true;
      case 'genders':
        cov_2lqxhfvlrd().b[18][4]++;
        cov_2lqxhfvlrd().s[62]++;
        if (valueFilter.length) {
          cov_2lqxhfvlrd().b[23][0]++;
          cov_2lqxhfvlrd().s[63]++;
          return PerformanceModel.searchByValue(valueFilter, 'gender', performance);
        } else {
          cov_2lqxhfvlrd().b[23][1]++;
        }
        cov_2lqxhfvlrd().s[64]++;
        return true;
      case 'demand':
        cov_2lqxhfvlrd().b[18][5]++;
        cov_2lqxhfvlrd().s[65]++;
        if (valueFilter.length) {
          cov_2lqxhfvlrd().b[24][0]++;
          cov_2lqxhfvlrd().s[66]++;
          return PerformanceModel.searchByValue(valueFilter, 'availability', performance);
        } else {
          cov_2lqxhfvlrd().b[24][1]++;
        }
        cov_2lqxhfvlrd().s[67]++;
        return true;
      case 'medals':
        cov_2lqxhfvlrd().b[18][6]++;
        cov_2lqxhfvlrd().s[68]++;
        if (valueFilter.length) {
          cov_2lqxhfvlrd().b[25][0]++;
          cov_2lqxhfvlrd().s[69]++;
          return PerformanceModel.searchByValue(valueFilter, 'medal', performance);
        } else {
          cov_2lqxhfvlrd().b[25][1]++;
        }
        cov_2lqxhfvlrd().s[70]++;
        return true;
      case 'timeDay':
        cov_2lqxhfvlrd().b[18][7]++;
        cov_2lqxhfvlrd().s[71]++;
        if (valueFilter.length) {
          cov_2lqxhfvlrd().b[26][0]++;
          cov_2lqxhfvlrd().s[72]++;
          return PerformanceModel.searchByValue(valueFilter, 'timeOfDay', performance);
        } else {
          cov_2lqxhfvlrd().b[26][1]++;
        }
        cov_2lqxhfvlrd().s[73]++;
        return true;
      case 'venue':
        cov_2lqxhfvlrd().b[18][8]++;
        cov_2lqxhfvlrd().s[74]++;
        if ((cov_2lqxhfvlrd().b[28][0]++, valueFilter.length) && (cov_2lqxhfvlrd().b[28][1]++, valueFilter[0].value !== 0)) {
          cov_2lqxhfvlrd().b[27][0]++;
          cov_2lqxhfvlrd().s[75]++;
          return PerformanceModel.searchByValue(valueFilter, 'venue', performance);
        } else {
          cov_2lqxhfvlrd().b[27][1]++;
        }
        cov_2lqxhfvlrd().s[76]++;
        return true;
      default:
        cov_2lqxhfvlrd().b[18][9]++;
        cov_2lqxhfvlrd().s[77]++;
        return true;
    }
  },
  /**
   * Comparison between two objects through a field with a order (ascending\descending)
   * @param {Boolean} ascending, indicate if ascending(true) or descending(false)
   * @param {object} performance1, performance to compare
   * @param {object} performance2, performance to compare
   * @param {string} field, value to compare between performances
   *
   * @return 1 is greater, -1 is less or 0 is equal
   */
  sortByField: function sortByField(ascending, performance1, performance2, field) {
    cov_2lqxhfvlrd().f[16]++;
    var comparison = (cov_2lqxhfvlrd().s[78]++, 0);
    var parsedField = (cov_2lqxhfvlrd().s[79]++, PerformanceModel.parserFieldPerformance(field));
    cov_2lqxhfvlrd().s[80]++;
    if (parsedField) {
      cov_2lqxhfvlrd().b[29][0]++;
      var fieldA = (cov_2lqxhfvlrd().s[81]++, '');
      var fieldB = (cov_2lqxhfvlrd().s[82]++, '');
      cov_2lqxhfvlrd().s[83]++;
      if (performance1[parsedField] !== undefined) {
        cov_2lqxhfvlrd().b[30][0]++;
        cov_2lqxhfvlrd().s[84]++;
        fieldA = performance1[parsedField];
      } else {
        cov_2lqxhfvlrd().b[30][1]++;
      }
      cov_2lqxhfvlrd().s[85]++;
      if (performance2[parsedField] !== undefined) {
        cov_2lqxhfvlrd().b[31][0]++;
        cov_2lqxhfvlrd().s[86]++;
        fieldB = performance2[parsedField];
      } else {
        cov_2lqxhfvlrd().b[31][1]++;
      }
      cov_2lqxhfvlrd().s[87]++;
      if (fieldA > fieldB) {
        cov_2lqxhfvlrd().b[32][0]++;
        cov_2lqxhfvlrd().s[88]++;
        comparison = ascending ? (cov_2lqxhfvlrd().b[33][0]++, 1) : (cov_2lqxhfvlrd().b[33][1]++, -1);
      } else {
        cov_2lqxhfvlrd().b[32][1]++;
        cov_2lqxhfvlrd().s[89]++;
        if (fieldA < fieldB) {
          cov_2lqxhfvlrd().b[34][0]++;
          cov_2lqxhfvlrd().s[90]++;
          comparison = ascending ? (cov_2lqxhfvlrd().b[35][0]++, -1) : (cov_2lqxhfvlrd().b[35][1]++, 1);
        } else {
          cov_2lqxhfvlrd().b[34][1]++;
        }
      }
    } else {
      cov_2lqxhfvlrd().b[29][1]++;
    }
    cov_2lqxhfvlrd().s[91]++;
    return comparison;
  },
  parserFieldPerformance: function parserFieldPerformance(field) {
    cov_2lqxhfvlrd().f[17]++;
    cov_2lqxhfvlrd().s[92]++;
    switch (field) {
      case 'performance':
        cov_2lqxhfvlrd().b[36][0]++;
        cov_2lqxhfvlrd().s[93]++;
        return 'name';
      case 'dateTime':
        cov_2lqxhfvlrd().b[36][1]++;
        cov_2lqxhfvlrd().s[94]++;
        return 'timeStart';
      case 'description':
        cov_2lqxhfvlrd().b[36][2]++;
        cov_2lqxhfvlrd().s[95]++;
        return 'description';
      case 'venue':
        cov_2lqxhfvlrd().b[36][3]++;
        cov_2lqxhfvlrd().s[96]++;
        return 'venue';
      case 'price':
        cov_2lqxhfvlrd().b[36][4]++;
        cov_2lqxhfvlrd().s[97]++;
        return 'minAmount';
      case 'demand':
        cov_2lqxhfvlrd().b[36][5]++;
        cov_2lqxhfvlrd().s[98]++;
        return 'availability';
      default:
        cov_2lqxhfvlrd().b[36][6]++;
        cov_2lqxhfvlrd().s[99]++;
        return null;
    }
  },
  /**
   * Search in a performace of the session catalog to see whether the keyword exists
   * If there is at least one match, return true
   * @param {array} tokens, array of token text values
   * @param {object} performance, object with the content of a performance
   *
   * @returns Boolean indicating if there is a coincidende
   */
  searchPerformance: function searchPerformance(tokens, performance) {
    cov_2lqxhfvlrd().f[18]++;
    var isMatched = (cov_2lqxhfvlrd().s[100]++, false);
    // do not check against only whitespaces
    var filteredTokens = (cov_2lqxhfvlrd().s[101]++, tokens.filter(function (token) {
      cov_2lqxhfvlrd().f[19]++;
      cov_2lqxhfvlrd().s[102]++;
      return !!token.replace(/\s/g, '');
    }));
    cov_2lqxhfvlrd().s[103]++;
    filteredTokens.forEach(function (value) {
      cov_2lqxhfvlrd().f[20]++;
      var currentToken = (cov_2lqxhfvlrd().s[104]++, value.toLowerCase());
      // Applies on disciplines, session and zones
      cov_2lqxhfvlrd().s[105]++;
      isMatched = (cov_2lqxhfvlrd().b[37][0]++, performance.name) && (cov_2lqxhfvlrd().b[37][1]++, performance.name.toLowerCase().indexOf(currentToken) >= 0) || (cov_2lqxhfvlrd().b[37][2]++, performance.code) && (cov_2lqxhfvlrd().b[37][3]++, performance.code.toLowerCase().indexOf(currentToken) >= 0) || (cov_2lqxhfvlrd().b[37][4]++, performance.venue) && (cov_2lqxhfvlrd().b[37][5]++, performance.venue.toLowerCase().indexOf(currentToken) >= 0) || (cov_2lqxhfvlrd().b[37][6]++, performance.zone) && (cov_2lqxhfvlrd().b[37][7]++, performance.zone.toLowerCase().indexOf(currentToken) >= 0) || (cov_2lqxhfvlrd().b[37][8]++, performance.description) && (cov_2lqxhfvlrd().b[37][9]++, performance.description.toLowerCase().indexOf(currentToken) >= 0);
    });
    cov_2lqxhfvlrd().s[106]++;
    return isMatched;
  },
  /**
   * Search the value inside the field of performance. Return true as soon as find the
   * value searched
   * @param {array} value,       array of values to search
   * @param {string} field,       key to locate in the performance
   * @param {object} performance, contains the performance
   *
   * @return {boolean} true if the value match with the field performance
   */
  searchByValue: function searchByValue(value, field, performance) {
    cov_2lqxhfvlrd().f[21]++;
    cov_2lqxhfvlrd().s[107]++;
    return value.some(function (item) {
      cov_2lqxhfvlrd().f[22]++;
      cov_2lqxhfvlrd().s[108]++;
      return item.value === performance[field];
    });
  }
});
var VisitThemeModel = (cov_2lqxhfvlrd().s[109]++, {
  /**
   * This function is used to transform product data received by the server to product data that will be used in
   * the nucleo (state) and all the functional components
   * @param {object} data, it is the value of visit received by the server
   * @param {ConfigType} config, it is the nucleo config object
   * @returns VisitThemeType
   */
  get: function get(data, config) {
    cov_2lqxhfvlrd().f[23]++;
    var _ref7 = (cov_2lqxhfvlrd().s[110]++, config),
      language = _ref7.language,
      defaultLanguage = _ref7.defaultLanguage;
    var adaptedData = (cov_2lqxhfvlrd().s[111]++, {
      // get the translated objects to avoid computing it everywhere, but keep all translations
      rawName: data.name,
      name: (cov_2lqxhfvlrd().b[38][0]++, data.name) && ((cov_2lqxhfvlrd().b[38][1]++, data.name[language]) || (cov_2lqxhfvlrd().b[38][2]++, data.name[defaultLanguage]))
    });
    cov_2lqxhfvlrd().s[112]++;
    return _objectSpread(_objectSpread({}, data), adaptedData);
  },
  /**
   * Change the language of the visitTheme
   * @param {VisitThemeType} visitTheme, it is the value of visit received by the server
   * @param {string} language, the first language to try to get
   * @param {string} defaultLanguage, the fallback language if not exist
   * @returns VisitThemeType
   */
  changeLanguage: function changeLanguage(visitTheme, language, defaultLanguage) {
    cov_2lqxhfvlrd().f[24]++;
    var adaptedData = (cov_2lqxhfvlrd().s[113]++, {
      // get the translated objects to avoid computing it everywhere, but keep all translations
      rawName: visitTheme.rawName,
      name: getName(visitTheme.drawName, language, defaultLanguage)
    });
    cov_2lqxhfvlrd().s[114]++;
    return _objectSpread(_objectSpread({}, visitTheme), adaptedData);
  }
});
var TimeslotModel = (cov_2lqxhfvlrd().s[115]++, {
  /**
   * This function is used to transform product data received by the server to product data that will be used in
   * the nucleo (state) and all the functional components
   * @param {object} data, it is the value of timeslot received by the server
   * @param {ConfigType} config, it is the nucleo config object
   * @param {object} pricesByRateType, prices by rate type id
   * @returns TimeslotType
   */
  get: function get(data, config, pricesByRateType) {
    cov_2lqxhfvlrd().f[25]++;
    var adaptedData = (cov_2lqxhfvlrd().s[116]++, {});
    cov_2lqxhfvlrd().s[117]++;
    if ((cov_2lqxhfvlrd().b[40][0]++, data.visitThemes) && (cov_2lqxhfvlrd().b[40][1]++, data.visitThemes.length > 0)) {
      cov_2lqxhfvlrd().b[39][0]++;
      cov_2lqxhfvlrd().s[118]++;
      adaptedData.visitThemes = data.visitThemes.map(function (visitTheme) {
        cov_2lqxhfvlrd().f[26]++;
        cov_2lqxhfvlrd().s[119]++;
        return VisitThemeModel.get(visitTheme, config);
      });
    } else {
      cov_2lqxhfvlrd().b[39][1]++;
    }
    cov_2lqxhfvlrd().s[120]++;
    adaptedData.tariffs = (0, _get2.default)(pricesByRateType, data.rateTypeId, []).map(function (price) {
      cov_2lqxhfvlrd().f[27]++;
      cov_2lqxhfvlrd().s[121]++;
      return TariffModel.get(price, config);
    });
    cov_2lqxhfvlrd().s[122]++;
    return _objectSpread(_objectSpread({}, data), adaptedData);
  },
  /**
   * Change the language of the visit
   * @param {VisitType} visit, it is the value of visit received by the server
   * @param {string} language, the first language to try to get
   * @param {string} defaultLanguage, the fallback language if not exist
   * @returns VisitType
   */
  changeLanguage: function changeLanguage(visit, language, defaultLanguage) {
    cov_2lqxhfvlrd().f[28]++;
    var adaptedData = (cov_2lqxhfvlrd().s[123]++, {});
    cov_2lqxhfvlrd().s[124]++;
    if ((cov_2lqxhfvlrd().b[42][0]++, visit.visitThemes) && (cov_2lqxhfvlrd().b[42][1]++, visit.visitThemes.length > 0)) {
      cov_2lqxhfvlrd().b[41][0]++;
      cov_2lqxhfvlrd().s[125]++;
      adaptedData.visitThemes = visit.visitThemes.map(function (visitTheme) {
        cov_2lqxhfvlrd().f[29]++;
        cov_2lqxhfvlrd().s[126]++;
        return VisitThemeModel.changeLanguage(visitTheme, language, defaultLanguage);
      });
    } else {
      cov_2lqxhfvlrd().b[41][1]++;
    }
    cov_2lqxhfvlrd().s[127]++;
    return _objectSpread(_objectSpread({}, visit), adaptedData);
  }
});
var AdvantageModel = (cov_2lqxhfvlrd().s[128]++, {
  /**
   * This function is used to transform advantage data received by the server to product data that will be used in
   * the nucleo (state) and all the functional components
   * @param {object} data, it is the value of advantage received by the server
   * @param {ConfigType} config, it is the nucleo config object
   * @returns AdvantageType
   */
  get: function get(data, config) {
    cov_2lqxhfvlrd().f[30]++;
    var _ref8 = (cov_2lqxhfvlrd().s[129]++, config),
      language = _ref8.language,
      defaultLanguage = _ref8.defaultLanguage;
    var adaptedData = (cov_2lqxhfvlrd().s[130]++, {
      // get the translated objects to avoid computing it everywhere, but keep all translations
      rawName: data.name,
      name: getName(data.name, language, defaultLanguage),
      rawSubtitle: data.subtitle,
      subtitle: getName(data.subtitle, language, defaultLanguage),
      description: getName(data.description, language, defaultLanguage),
      rawDescription: data.description
    });
    cov_2lqxhfvlrd().s[131]++;
    return _objectSpread(_objectSpread({}, data), adaptedData);
  },
  /**
   * Change the language of the advantage
   * @param {AdvantageType} advantage, it is the value of visit received by the server
   * @param {string} language, the first language to try to get
   * @param {string} defaultLanguage, the fallback language if not exist
   * @returns AdvantageType
   */
  changeLanguage: function changeLanguage(advantage, language, defaultLanguage) {
    cov_2lqxhfvlrd().f[31]++;
    var adaptedData = (cov_2lqxhfvlrd().s[132]++, {
      // get the translated objects to avoid computing it everywhere, but keep all translations
      rawName: advantage.rawName,
      name: getName(advantage.rawName, language, defaultLanguage),
      rawSubtitle: advantage.rawSubtitle,
      subtitle: getName(advantage.rawSubtitle, language, defaultLanguage),
      rawDescription: advantage.rawDescription,
      description: getName(advantage.rawDescription, language, defaultLanguage)
    });
    cov_2lqxhfvlrd().s[133]++;
    return _objectSpread(_objectSpread({}, advantage), adaptedData);
  }
});
var ProductModel = (cov_2lqxhfvlrd().s[134]++, {
  /**
   * This function is used to transform product data received by the server to product data that will be used in
   * the nucleo (state) and all the functional components that take a Product as property
   * @param {object} data, it is the value of product received by the server
   * @param {ConfigType} config, it is the nucleo config object
   * @returns ProductType
   */
  get: function get(data, config) {
    cov_2lqxhfvlrd().f[32]++;
    var _ref9 = (cov_2lqxhfvlrd().s[135]++, config),
      language = _ref9.language,
      defaultLanguage = _ref9.defaultLanguage;
    var adaptedData = (cov_2lqxhfvlrd().s[136]++, {
      // get the translated objects to avoid computing it everywhere, but keep all translations
      rawName: data.name,
      name: getName(data.name, language, defaultLanguage),
      rawSubtitle: data.subtitle,
      subtitle: getName(data.subtitle, language, defaultLanguage),
      rawDescription: data.description,
      description: getName(data.description, language, defaultLanguage),
      minPrice: {
        amount: data.minAmount,
        currencyCode: config.currencyCode
      },
      plainPrice: (cov_2lqxhfvlrd().b[43][0]++, data.plainAmount) && (cov_2lqxhfvlrd().b[43][1]++, {
        amount: data.plainAmount,
        currencyCode: config.currencyCode
      })
    });
    cov_2lqxhfvlrd().s[137]++;
    adaptedData.performances = (0, _get2.default)(data, 'performances', []).map(function (performance) {
      cov_2lqxhfvlrd().f[33]++;
      cov_2lqxhfvlrd().s[138]++;
      return PerformanceModel.get(performance, adaptedData, config);
    });
    var pricesByRateType = (cov_2lqxhfvlrd().s[139]++, (0, _groupBy.default)(data.prices, function (price) {
      cov_2lqxhfvlrd().f[34]++;
      cov_2lqxhfvlrd().s[140]++;
      return price.rateTypeId;
    }));
    cov_2lqxhfvlrd().s[141]++;
    adaptedData.timeslots = (0, _get2.default)(data, 'timeslots', []).map(function (timeslot) {
      cov_2lqxhfvlrd().f[35]++;
      cov_2lqxhfvlrd().s[142]++;
      return TimeslotModel.get(timeslot, config, pricesByRateType);
    });
    cov_2lqxhfvlrd().s[143]++;
    adaptedData.sessions = (0, _get2.default)(data, 'sessions', []).map(function (session) {
      cov_2lqxhfvlrd().f[36]++;
      cov_2lqxhfvlrd().s[144]++;
      return HospitalitySessionModel.get(session, config);
    });
    cov_2lqxhfvlrd().s[145]++;
    adaptedData.packageLines = (0, _get2.default)(data, 'packageLines', []).map(function (packageLine) {
      cov_2lqxhfvlrd().f[37]++;
      cov_2lqxhfvlrd().s[146]++;
      return /* eslint-disable no-use-before-define */(
        PackageLineModel.get(packageLine, config)
      );
    }
    /* eslint-enable no-use-before-define */);
    cov_2lqxhfvlrd().s[147]++;
    adaptedData.advantages = (0, _get2.default)(data, 'advantages', []).map(function (advantage) {
      cov_2lqxhfvlrd().f[38]++;
      cov_2lqxhfvlrd().s[148]++;
      return AdvantageModel.get(advantage, config);
    });
    cov_2lqxhfvlrd().s[149]++;
    if (data.type) {
      cov_2lqxhfvlrd().b[44][0]++;
      cov_2lqxhfvlrd().s[150]++;
      adaptedData.type = {
        rawName: data.type.name,
        name: getName(data.type.name, language, defaultLanguage),
        code: data.type.code
      };
    } else {
      cov_2lqxhfvlrd().b[44][1]++;
    }
    cov_2lqxhfvlrd().s[151]++;
    if (!(0, _isEmpty.default)(data.prices)) {
      cov_2lqxhfvlrd().b[45][0]++;
      cov_2lqxhfvlrd().s[152]++;
      adaptedData.tariffs = (0, _get2.default)(data, 'prices', []).map(function (price) {
        cov_2lqxhfvlrd().f[39]++;
        cov_2lqxhfvlrd().s[153]++;
        return TariffModel.get(price, config);
      });
      cov_2lqxhfvlrd().s[154]++;
      adaptedData.prices = undefined;
    } else {
      cov_2lqxhfvlrd().b[45][1]++;
    }
    cov_2lqxhfvlrd().s[155]++;
    return _objectSpread(_objectSpread({}, data), adaptedData);
  },
  /**
   * Change the language of the product
   * @param {ProductType} product, it is the value of visit received by the server
   * @param {string} language, the first language to try to get
   * @param {string} defaultLanguage, the fallback language if not exist
   * @returns ProductType
   */
  changeLanguage: function changeLanguage(product, language, defaultLanguage) {
    cov_2lqxhfvlrd().f[40]++;
    var adaptedProduct = (cov_2lqxhfvlrd().s[156]++, {
      // get the translated objects to avoid computing it everywhere, but keep all translations
      rawName: product.rawName,
      name: getName(product.rawName, language, defaultLanguage),
      rawSubtitle: product.rawSubtitle,
      subtitle: getName(product.rawSubtitle, language, defaultLanguage),
      rawDescription: product.rawDescription,
      description: getName(product.rawDescription, language, defaultLanguage),
      tariffs: product.tariffs
    });

    // change language of performances
    cov_2lqxhfvlrd().s[157]++;
    adaptedProduct.performances = (0, _get2.default)(product, 'performances', []).map(function (performance) {
      cov_2lqxhfvlrd().f[41]++;
      cov_2lqxhfvlrd().s[158]++;
      return PerformanceModel.changeLanguage(performance, adaptedProduct, language, defaultLanguage);
    });

    // change language of timeslots
    cov_2lqxhfvlrd().s[159]++;
    adaptedProduct.timeslots = (0, _get2.default)(product, 'timeslots', []).map(function (timeslot) {
      cov_2lqxhfvlrd().f[42]++;
      cov_2lqxhfvlrd().s[160]++;
      return TimeslotModel.changeLanguage(timeslot, language, defaultLanguage);
    });

    // change language of hospitality session
    cov_2lqxhfvlrd().s[161]++;
    adaptedProduct.sessions = (0, _get2.default)(product, 'sessions', []).map(function (session) {
      cov_2lqxhfvlrd().f[43]++;
      cov_2lqxhfvlrd().s[162]++;
      return HospitalitySessionModel.changeLanguage(session, language, defaultLanguage);
    });

    // change language for package lines
    cov_2lqxhfvlrd().s[163]++;
    adaptedProduct.packageLines = (0, _get2.default)(product, 'packageLines', []).map(function (packageLine) {
      cov_2lqxhfvlrd().f[44]++;
      cov_2lqxhfvlrd().s[164]++;
      return /* eslint-disable no-use-before-define */(
        PackageLineModel.changeLanguage(packageLine, language, defaultLanguage)
      );
    }
    /* eslint-enable no-use-before-define */);

    // change language of advantages
    cov_2lqxhfvlrd().s[165]++;
    adaptedProduct.advantages = (0, _get2.default)(product, 'advantages', []).map(function (advantage) {
      cov_2lqxhfvlrd().f[45]++;
      cov_2lqxhfvlrd().s[166]++;
      return AdvantageModel.changeLanguage(advantage, language, defaultLanguage);
    });

    // change language of tariffs
    cov_2lqxhfvlrd().s[167]++;
    adaptedProduct.tariffs = (0, _get2.default)(product, 'tariffs', []).map(function (tariff) {
      cov_2lqxhfvlrd().f[46]++;
      cov_2lqxhfvlrd().s[168]++;
      return TariffModel.changeLanguage(tariff, language, defaultLanguage);
    });
    cov_2lqxhfvlrd().s[169]++;
    if (product.type) {
      cov_2lqxhfvlrd().b[46][0]++;
      cov_2lqxhfvlrd().s[170]++;
      adaptedProduct.type = {
        rawName: product.type.rawName,
        name: getName(product.type.name, language, defaultLanguage),
        code: product.type.code
      };
    } else {
      cov_2lqxhfvlrd().b[46][1]++;
    }
    cov_2lqxhfvlrd().s[171]++;
    return (0, _assign.default)({}, product, adaptedProduct);
  },
  // for a product containing only one performance or one timeslot (i.e. it means that it is a timeslot or a performance)
  // get the date
  getDate: function getDate(product) {
    cov_2lqxhfvlrd().f[47]++;
    cov_2lqxhfvlrd().s[172]++;
    return (cov_2lqxhfvlrd().b[47][0]++, ProductModel.getOccurrences(product)[0]) && (cov_2lqxhfvlrd().b[47][1]++, ProductModel.getOccurrences(product)[0].start);
  },
  isBefore: function isBefore(product1, product2, config) {
    cov_2lqxhfvlrd().f[48]++;
    var date1 = (cov_2lqxhfvlrd().s[173]++, ProductModel.getDate(product1));
    var date2 = (cov_2lqxhfvlrd().s[174]++, ProductModel.getDate(product2));
    var dateResult = (cov_2lqxhfvlrd().s[175]++, (0, _compare_asc.default)(date1, date2));
    cov_2lqxhfvlrd().s[176]++;
    if (dateResult !== 0) {
      cov_2lqxhfvlrd().b[48][0]++;
      cov_2lqxhfvlrd().s[177]++;
      return dateResult;
    } else {
      cov_2lqxhfvlrd().b[48][1]++;
    }
    var name1 = (cov_2lqxhfvlrd().s[178]++, (cov_2lqxhfvlrd().b[49][0]++, ProductModel.get(product1, config).name) || (cov_2lqxhfvlrd().b[49][1]++, ''));
    var name2 = (cov_2lqxhfvlrd().s[179]++, (cov_2lqxhfvlrd().b[50][0]++, ProductModel.get(product2, config).name) || (cov_2lqxhfvlrd().b[50][1]++, ''));
    cov_2lqxhfvlrd().s[180]++;
    return name1.localeCompare(name2);
  },
  // assume that if the product has a name defined, data are loaded
  hasData: function hasData(product) {
    cov_2lqxhfvlrd().f[49]++;
    cov_2lqxhfvlrd().s[181]++;
    return product.name;
  },
  /**
   * Function to know if the tariff has already been loaded and is present
   */
  hasTariff: function hasTariff(product) {
    cov_2lqxhfvlrd().f[50]++;
    cov_2lqxhfvlrd().s[182]++;
    return (cov_2lqxhfvlrd().b[51][0]++, product.tariffs) && (cov_2lqxhfvlrd().b[51][1]++, product.tariffs.length > 0);
  },
  /**
   * giving the product and the options retrieve the corresponding performance
   * The option may contain
   *  the occurrenceId -> if exist, return the value (or empty if there is no occurrence with this id)
   *  selector -> if the occurrenceId is empty, use the selector, supported value : 'FIRST'
   *    FIRST : obviously get the
   */
  findOccurrence: function findOccurrence(product, options) {
    cov_2lqxhfvlrd().f[51]++;
    var occurrences = (cov_2lqxhfvlrd().s[183]++, ProductModel.getOccurrences(product));
    cov_2lqxhfvlrd().s[184]++;
    if (options.occurrenceId) {
      cov_2lqxhfvlrd().b[52][0]++;
      cov_2lqxhfvlrd().s[185]++;
      return occurrences.find(function (occurrence) {
        cov_2lqxhfvlrd().f[52]++;
        cov_2lqxhfvlrd().s[186]++;
        return occurrence.id === options.occurrenceId;
      });
    } else {
      cov_2lqxhfvlrd().b[52][1]++;
      cov_2lqxhfvlrd().s[187]++;
      if (options.selector === 'FIRST') {
        cov_2lqxhfvlrd().b[53][0]++;
        cov_2lqxhfvlrd().s[188]++;
        // the occurrences are sorted by date, so far it is enough to take the first value in the array
        return occurrences[0];
      } else {
        cov_2lqxhfvlrd().b[53][1]++;
      }
    }
    cov_2lqxhfvlrd().s[189]++;
    return undefined;
  },
  getOccurrences: function getOccurrences(product) {
    cov_2lqxhfvlrd().f[53]++;
    cov_2lqxhfvlrd().s[190]++;
    var isNotEmpty = function isNotEmpty(arr) {
      cov_2lqxhfvlrd().f[54]++;
      cov_2lqxhfvlrd().s[191]++;
      return (cov_2lqxhfvlrd().b[54][0]++, arr) && (cov_2lqxhfvlrd().b[54][1]++, !(0, _isEmpty.default)(arr));
    };
    cov_2lqxhfvlrd().s[192]++;
    if (isNotEmpty(product.occurrences)) {
      cov_2lqxhfvlrd().b[55][0]++;
      cov_2lqxhfvlrd().s[193]++;
      return product.occurrences;
    } else {
      cov_2lqxhfvlrd().b[55][1]++;
    }
    cov_2lqxhfvlrd().s[194]++;
    if (isNotEmpty(product.performances)) {
      cov_2lqxhfvlrd().b[56][0]++;
      cov_2lqxhfvlrd().s[195]++;
      return product.performances;
    } else {
      cov_2lqxhfvlrd().b[56][1]++;
    }
    cov_2lqxhfvlrd().s[196]++;
    if (isNotEmpty(product.timeslots)) {
      cov_2lqxhfvlrd().b[57][0]++;
      cov_2lqxhfvlrd().s[197]++;
      return product.timeslots;
    } else {
      cov_2lqxhfvlrd().b[57][1]++;
    }
    cov_2lqxhfvlrd().s[198]++;
    return [];
  },
  /**
   * if the product is an occurrence (i.e. there is only one performance or timeslot in the array)
   * return the occurrence, if not return empty
   */
  getOccurrence: function getOccurrence(product) {
    cov_2lqxhfvlrd().f[55]++;
    var occurrences = (cov_2lqxhfvlrd().s[199]++, ProductModel.getOccurrences(product));
    cov_2lqxhfvlrd().s[200]++;
    return occurrences.length === 1 ? (cov_2lqxhfvlrd().b[58][0]++, occurrences[0]) : (cov_2lqxhfvlrd().b[58][1]++, undefined);
  },
  getCustomAction: function getCustomAction(product, queryParam) {
    cov_2lqxhfvlrd().f[56]++;
    cov_2lqxhfvlrd().s[201]++;
    return _objectSpread(_objectSpread({}, product), {}, {
      action: (0, _entries.default)(product.action).reduce(function (acc, entry) {
        cov_2lqxhfvlrd().f[57]++;
        cov_2lqxhfvlrd().s[202]++;
        acc[entry[0]] = entry[1] + queryParam;
        cov_2lqxhfvlrd().s[203]++;
        return acc;
      }, {})
    });
  },
  getProductType: function getProductType(product) {
    cov_2lqxhfvlrd().f[58]++;
    cov_2lqxhfvlrd().s[204]++;
    return product.type ? (cov_2lqxhfvlrd().b[59][0]++, product.type.name) : (cov_2lqxhfvlrd().b[59][1]++, '');
  }
});
var PackageLineModel = exports.PackageLineModel = (cov_2lqxhfvlrd().s[205]++, {
  /**
   * This function is used to transform product data received by the server to product data that will be used in
   * the nucleo (state) and all the functional components
   * It needs the original productData to get the basic name
   * @param {object} data, it is the value of package line model received by the server
   * @param {object} productData, it is the value of product received by the server
   * @param {ConfigType} config, it is the nucleo config object
   */
  get: function get(data, config) {
    cov_2lqxhfvlrd().f[59]++;
    var adaptedData = (cov_2lqxhfvlrd().s[206]++, {
      id: data.id,
      packageProduct: (cov_2lqxhfvlrd().b[60][0]++, data.packageProduct) && (cov_2lqxhfvlrd().b[60][1]++, ProductModel.get(data.packageProduct, config))
    });
    cov_2lqxhfvlrd().s[207]++;
    return _objectSpread(_objectSpread({}, data), adaptedData);
  },
  /**
   * Get a language and return the performance with the new translation
   */
  changeLanguage: function changeLanguage(data, language, defaultLanguage) {
    cov_2lqxhfvlrd().f[60]++;
    var adaptedData = (cov_2lqxhfvlrd().s[208]++, {
      id: data.id,
      packageProduct: ProductModel.changeLanguage(data.packageProduct, language, defaultLanguage)
    });
    cov_2lqxhfvlrd().s[209]++;
    return _objectSpread(_objectSpread({}, data), adaptedData);
  }
});
var _default = exports.default = ProductModel;